/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(320));
	    processInclude(__webpack_require__(235));
	    processInclude(__webpack_require__(233));
	});

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	"use strict";

	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),

/***/ 177:
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    setTabNextFocus: function setTabNextFocus(focusParams) {
	        var KEYCODE_TAB = 9;
	        var isTabPressed = focusParams.event.key === 'Tab' || focusParams.event.keyCode === KEYCODE_TAB;

	        if (!isTabPressed) {
	            return;
	        }

	        var firstFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.firstElementSelector);
	        var lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.lastElementSelector);

	        if ($(focusParams.containerSelector + ' ' + focusParams.lastElementSelector).is(':disabled')) {
	            lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.nextToLastElementSelector);
	            if ($('.product-quickview.product-set').length > 0) {
	                var linkElements = $(focusParams.containerSelector + ' a#fa-link.share-icons');
	                lastFocusableEl = linkElements[linkElements.length - 1];
	            }
	        }

	        if (focusParams.event.shiftKey) /* shift + tab */{
	                if ($(':focus').is(firstFocusableEl)) {
	                    lastFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            } else /* tab */{
	                if ($(':focus').is(lastFocusableEl)) {
	                    // eslint-disable-line
	                    firstFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            }
	    }
	};

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	//enables lazyload in pdp

	var picture_lazy_load = __webpack_require__(183);
	picture_lazy_load.init();

	function hideAddToWishlistButtonInPDP() {
	    $('.product-detail .prices-add-to-cart-actions .add-to-wish-list').hide();
	}
	hideAddToWishlistButtonInPDP();

	function selectASizeHintWishList() {
	    $('.container').on('click', '.add-to-wish-list', function () {
	        var $self = $(this);
	        if (!$self.hasClass('to-add to-remove')) {

	            var $overlay = $self.parents('.product-tile').find('.js-tile-open-overlay');
	            // PLP case for VG products to not open the size drawer.
	            if ($overlay.hasClass('js-noSize') || $self.attr('data-is-size-selected') === 'null') {
	                return;
	            } else {
	                $self.closest('.cc-col-tile').addClass('js-addWishlist');
	                $overlay.trigger('click');
	            }
	        }
	    });
	}

	selectASizeHintWishList();

	//this function is to use only if variationGroups have different type of size
	// function modifyUrlColorSwatchesToSingleVariant($sizeTile) {
	//     var urlVariantValue = $sizeTile.attr('value');
	//     var sizeValue = $sizeTile.attr('data-attr-value');
	//     var $colorSwatches = $('.attributes .swatches-container .color-attribute');
	//     var urlToReplace;
	//     $colorSwatches.each(function () {
	//         var element = $(this).find('.color-value');
	//         var colorValue = element.attr('data-attr-value');
	//         urlToReplace = urlVariantValue;
	//         urlToReplace = urlToReplace.replace(/(?<=size=)(.*?)((?=&)|(?=$))/, sizeValue);
	//         urlToReplace = urlToReplace.replace(/(?<=color=)(.*?)((?=&)|(?=$))/, colorValue);
	//         $(this).attr('data-url', urlToReplace);
	//     })
	// }

	/**
	 * Retrieves the relevant pid value
	 * @param {jquery} $el - DOM container for a given add to cart button
	 * @return {string} - value to be used when adding product to cart
	 */
	function getPidValue($el) {
	    var pid;

	    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length > 0) {
	        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
	    } else if ($($el).closest('.product-tile').length > 0) {
	        pid = $($el).data('pid');
	    } else if ($($el).closest('.product-set').length > 0 || $('.product-set').length > 0) {
	        pid = $($el).closest('.product-detail').find('.product-id').text();
	    } else {
	        pid = $('.product-detail:not(".bundle-item")').data('pid');
	    }

	    return pid;
	}

	/**
	 * Makes a call to the server to report the event of adding an item to the cart
	 *
	 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
	 */
	function miniCartReportingUrl(url) {
	    if (url) {
	        $.ajax({
	            url: url,
	            method: 'GET',
	            success: function success() {
	                // reporting urls hit on the server
	            },
	            error: function error() {
	                // no reporting urls hit on the server
	            }
	        });
	    }
	}

	module.exports = {
	    getPidValue: getPidValue,
	    miniCartReportingUrl: miniCartReportingUrl
	};

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	    init: function init() {
	        //var featureDetect = require('./featureDetect');

	        var lazySizesConfig = window.lazySizesConfig = window.lazySizesConfig || {};
	        lazySizesConfig.init = false;
	        lazySizesConfig.loadMode = 2;
	        lazySizesConfig.preloadAfterLoad = false;
	        lazySizesConfig.ricTimeout = 250;
	        lazySizesConfig.expand = 700;
	        lazySizesConfig.loadHidden = false;
	        lazySizesConfig.srcAttr = 'data-lazy';
	        lazySizesConfig.srcsetAttr = 'data-srcset';
	        lazySizesConfig.sizesAttr = 'data-sizes';
	        lazySizesConfig.lazyClass = 'b-lazyload';
	        lazySizesConfig.loadingClass = 'b-lazyload_loading';
	        lazySizesConfig.loadedClass = 'b-lazyload_loaded';

	        var lazysizes = __webpack_require__(184);

	        document.addEventListener('lazybeforeunveil', function (e) {
	            var bg = e.target.getAttribute('data-bg');
	            if (bg) {
	                e.target.style.backgroundImage = 'url(' + bg + ')';
	            }
	        });

	        lazysizes.init();
	        // if (!featureDetect.hasPicture) {
	        //     import( /* webpackChunkName: "picturefill" */ 'picturefill').then((loadedModule) => {
	        //         loadedModule.default();
	        //         lazysizes.init();
	        //     });
	        // } else {
	        //     lazysizes.init();
	        // }

	    }
	};

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	(function (window, factory) {
		var lazySizes = factory(window, window.document);
		window.lazySizes = lazySizes;
		if (( false ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
			module.exports = lazySizes;
		}
	})(window, function l(window, document) {
		'use strict';
		/*jshint eqnull:true */

		if (!document.getElementsByClassName) {
			return;
		}

		var lazysizes, lazySizesConfig;

		var docElem = document.documentElement;

		var Date = window.Date;

		var supportPicture = window.HTMLPictureElement;

		var _addEventListener = 'addEventListener';

		var _getAttribute = 'getAttribute';

		var addEventListener = window[_addEventListener];

		var setTimeout = window.setTimeout;

		var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

		var requestIdleCallback = window.requestIdleCallback;

		var regPicture = /^picture$/i;

		var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

		var regClassCache = {};

		var forEach = Array.prototype.forEach;

		var hasClass = function hasClass(ele, cls) {
			if (!regClassCache[cls]) {
				regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
			}
			return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
		};

		var addClass = function addClass(ele, cls) {
			if (!hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
			}
		};

		var removeClass = function removeClass(ele, cls) {
			var reg;
			if (reg = hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
			}
		};

		var addRemoveLoadEvents = function addRemoveLoadEvents(dom, fn, add) {
			var action = add ? _addEventListener : 'removeEventListener';
			if (add) {
				addRemoveLoadEvents(dom, fn);
			}
			loadEvents.forEach(function (evt) {
				dom[action](evt, fn);
			});
		};

		var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
			var event = document.createEvent('Event');

			if (!detail) {
				detail = {};
			}

			detail.instance = lazysizes;

			event.initEvent(name, !noBubbles, !noCancelable);

			event.detail = detail;

			elem.dispatchEvent(event);
			return event;
		};

		var updatePolyfill = function updatePolyfill(el, full) {
			var polyfill;
			if (!supportPicture && (polyfill = window.picturefill || lazySizesConfig.pf)) {
				if (full && full.src && !el[_getAttribute]('srcset')) {
					el.setAttribute('srcset', full.src);
				}
				polyfill({ reevaluate: true, elements: [el] });
			} else if (full && full.src) {
				el.src = full.src;
			}
		};

		var getCSS = function getCSS(elem, style) {
			return (getComputedStyle(elem, null) || {})[style];
		};

		var getWidth = function getWidth(elem, parent, width) {
			width = width || elem.offsetWidth;

			while (width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth) {
				width = parent.offsetWidth;
				parent = parent.parentNode;
			}

			return width;
		};

		var rAF = function () {
			var running, waiting;
			var firstFns = [];
			var secondFns = [];
			var fns = firstFns;

			var run = function run() {
				var runFns = fns;

				fns = firstFns.length ? secondFns : firstFns;

				running = true;
				waiting = false;

				while (runFns.length) {
					runFns.shift()();
				}

				running = false;
			};

			var rafBatch = function rafBatch(fn, queue) {
				if (running && !queue) {
					fn.apply(this, arguments);
				} else {
					fns.push(fn);

					if (!waiting) {
						waiting = true;
						(document.hidden ? setTimeout : requestAnimationFrame)(run);
					}
				}
			};

			rafBatch._lsFlush = run;

			return rafBatch;
		}();

		var rAFIt = function rAFIt(fn, simple) {
			return simple ? function () {
				rAF(fn);
			} : function () {
				var that = this;
				var args = arguments;
				rAF(function () {
					fn.apply(that, args);
				});
			};
		};

		var throttle = function throttle(fn) {
			var running;
			var lastTime = 0;
			var gDelay = lazySizesConfig.throttleDelay;
			var rICTimeout = lazySizesConfig.ricTimeout;
			var run = function run() {
				running = false;
				lastTime = Date.now();
				fn();
			};
			var idleCallback = requestIdleCallback && rICTimeout > 49 ? function () {
				requestIdleCallback(run, { timeout: rICTimeout });

				if (rICTimeout !== lazySizesConfig.ricTimeout) {
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} : rAFIt(function () {
				setTimeout(run);
			}, true);

			return function (isPriority) {
				var delay;

				if (isPriority = isPriority === true) {
					rICTimeout = 33;
				}

				if (running) {
					return;
				}

				running = true;

				delay = gDelay - (Date.now() - lastTime);

				if (delay < 0) {
					delay = 0;
				}

				if (isPriority || delay < 9) {
					idleCallback();
				} else {
					setTimeout(idleCallback, delay);
				}
			};
		};

		//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
		var debounce = function debounce(func) {
			var timeout, timestamp;
			var wait = 99;
			var run = function run() {
				timeout = null;
				func();
			};
			var later = function later() {
				var last = Date.now() - timestamp;

				if (last < wait) {
					setTimeout(later, wait - last);
				} else {
					(requestIdleCallback || run)(run);
				}
			};

			return function () {
				timestamp = Date.now();

				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
			};
		};

		(function () {
			var prop;

			var lazySizesDefaults = {
				lazyClass: 'lazyload',
				loadedClass: 'lazyloaded',
				loadingClass: 'lazyloading',
				preloadClass: 'lazypreload',
				errorClass: 'lazyerror',
				//strictClass: 'lazystrict',
				autosizesClass: 'lazyautosizes',
				srcAttr: 'data-src',
				srcsetAttr: 'data-srcset',
				sizesAttr: 'data-sizes',
				//preloadAfterLoad: false,
				minSize: 40,
				customMedia: {},
				init: true,
				expFactor: 1.5,
				hFac: 0.8,
				loadMode: 2,
				loadHidden: true,
				ricTimeout: 0,
				throttleDelay: 125
			};

			lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

			for (prop in lazySizesDefaults) {
				if (!(prop in lazySizesConfig)) {
					lazySizesConfig[prop] = lazySizesDefaults[prop];
				}
			}

			window.lazySizesConfig = lazySizesConfig;

			setTimeout(function () {
				if (lazySizesConfig.init) {
					init();
				}
			});
		})();

		var loader = function () {
			var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

			var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

			var regImg = /^img$/i;
			var regIframe = /^iframe$/i;

			var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);

			var shrinkExpand = 0;
			var currentExpand = 0;

			var isLoading = 0;
			var lowRuns = -1;

			var resetPreloading = function resetPreloading(e) {
				isLoading--;
				if (!e || isLoading < 0 || !e.target) {
					isLoading = 0;
				}
			};

			var isVisible = function isVisible(elem) {
				if (isBodyHidden == null) {
					isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
				}

				return isBodyHidden || getCSS(elem.parentNode, 'visibility') != 'hidden' && getCSS(elem, 'visibility') != 'hidden';
			};

			var isNestedVisible = function isNestedVisible(elem, elemExpand) {
				var outerRect;
				var parent = elem;
				var visible = isVisible(elem);

				eLtop -= elemExpand;
				eLbottom += elemExpand;
				eLleft -= elemExpand;
				eLright += elemExpand;

				while (visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem) {
					visible = (getCSS(parent, 'opacity') || 1) > 0;

					if (visible && getCSS(parent, 'overflow') != 'visible') {
						outerRect = parent.getBoundingClientRect();
						visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
					}
				}

				return visible;
			};

			var checkElements = function checkElements() {
				var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
				var lazyloadElems = lazysizes.elements;

				if ((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {

					i = 0;

					lowRuns++;

					defaultExpand = !lazySizesConfig.expand || lazySizesConfig.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesConfig.expand;

					lazysizes._defEx = defaultExpand;

					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
					hFac = lazySizesConfig.hFac;
					isBodyHidden = null;

					if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
						currentExpand = preloadExpand;
						lowRuns = 0;
					} else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
						currentExpand = defaultExpand;
					} else {
						currentExpand = shrinkExpand;
					}

					for (; i < eLlen; i++) {

						if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
							continue;
						}

						if (!supportScroll) {
							unveilElement(lazyloadElems[i]);continue;
						}

						if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) {
							elemExpand = currentExpand;
						}

						if (beforeExpandVal !== elemExpand) {
							eLvW = innerWidth + elemExpand * hFac;
							elvH = innerHeight + elemExpand;
							elemNegativeExpand = elemExpand * -1;
							beforeExpandVal = elemExpand;
						}

						rect = lazyloadElems[i].getBoundingClientRect();

						if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesConfig.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
							unveilElement(lazyloadElems[i]);
							loadedSomething = true;
							if (isLoading > 9) {
								break;
							}
						} else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesConfig.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto'))) {
							autoLoadElem = preloadElems[0] || lazyloadElems[i];
						}
					}

					if (autoLoadElem && !loadedSomething) {
						unveilElement(autoLoadElem);
					}
				}
			};

			var throttledCheckElements = throttle(checkElements);

			var switchLoadingClass = function switchLoadingClass(e) {
				var elem = e.target;

				if (elem._lazyCache) {
					delete elem._lazyCache;
					return;
				}

				resetPreloading(e);
				addClass(elem, lazySizesConfig.loadedClass);
				removeClass(elem, lazySizesConfig.loadingClass);
				addRemoveLoadEvents(elem, rafSwitchLoadingClass);
				triggerEvent(elem, 'lazyloaded');
			};
			var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
			var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
				rafedSwitchLoadingClass({ target: e.target });
			};

			var changeIframeSrc = function changeIframeSrc(elem, src) {
				try {
					elem.contentWindow.location.replace(src);
				} catch (e) {
					elem.src = src;
				}
			};

			var handleSources = function handleSources(source) {
				var customMedia;

				var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

				if (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) {
					source.setAttribute('media', customMedia);
				}

				if (sourceSrcset) {
					source.setAttribute('srcset', sourceSrcset);
				}
			};

			var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
				var src, srcset, parent, isPicture, event, firesLoad;

				if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {

					if (sizes) {
						if (isAuto) {
							addClass(elem, lazySizesConfig.autosizesClass);
						} else {
							elem.setAttribute('sizes', sizes);
						}
					}

					srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
					src = elem[_getAttribute](lazySizesConfig.srcAttr);

					if (isImg) {
						parent = elem.parentNode;
						isPicture = parent && regPicture.test(parent.nodeName || '');
					}

					firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);

					event = { target: elem };

					addClass(elem, lazySizesConfig.loadingClass);

					if (firesLoad) {
						clearTimeout(resetPreloadingTimer);
						resetPreloadingTimer = setTimeout(resetPreloading, 2500);
						addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
					}

					if (isPicture) {
						forEach.call(parent.getElementsByTagName('source'), handleSources);
					}

					if (srcset) {
						elem.setAttribute('srcset', srcset);
					} else if (src && !isPicture) {
						if (regIframe.test(elem.nodeName)) {
							changeIframeSrc(elem, src);
						} else {
							elem.src = src;
						}
					}

					if (isImg && (srcset || isPicture)) {
						updatePolyfill(elem, { src: src });
					}
				}

				if (elem._lazyRace) {
					delete elem._lazyRace;
				}
				removeClass(elem, lazySizesConfig.lazyClass);

				rAF(function () {
					// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
					var isLoaded = elem.complete && elem.naturalWidth > 1;

					if (!firesLoad || isLoaded) {
						if (isLoaded) {
							addClass(elem, 'ls-is-cached');
						}
						switchLoadingClass(event);
						elem._lazyCache = true;
						setTimeout(function () {
							if ('_lazyCache' in elem) {
								delete elem._lazyCache;
							}
						}, 9);
					}
				}, true);
			});

			var unveilElement = function unveilElement(elem) {
				var detail;

				var isImg = regImg.test(elem.nodeName);

				//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
				var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
				var isAuto = sizes == 'auto';

				if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)) {
					return;
				}

				detail = triggerEvent(elem, 'lazyunveilread').detail;

				if (isAuto) {
					autoSizer.updateElem(elem, true, elem.offsetWidth);
				}

				elem._lazyRace = true;
				isLoading++;

				lazyUnveil(elem, detail, isAuto, sizes, isImg);
			};

			var onload = function onload() {
				if (isCompleted) {
					return;
				}
				if (Date.now() - started < 999) {
					setTimeout(onload, 999);
					return;
				}
				var afterScroll = debounce(function () {
					lazySizesConfig.loadMode = 3;
					throttledCheckElements();
				});

				isCompleted = true;

				lazySizesConfig.loadMode = 3;

				throttledCheckElements();

				addEventListener('scroll', function () {
					if (lazySizesConfig.loadMode == 3) {
						lazySizesConfig.loadMode = 2;
					}
					afterScroll();
				}, true);
			};

			return {
				_: function _() {
					started = Date.now();

					lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
					preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);

					addEventListener('scroll', throttledCheckElements, true);

					addEventListener('resize', throttledCheckElements, true);

					if (window.MutationObserver) {
						new MutationObserver(throttledCheckElements).observe(docElem, { childList: true, subtree: true, attributes: true });
					} else {
						docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
						docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
						setInterval(throttledCheckElements, 999);
					}

					addEventListener('hashchange', throttledCheckElements, true);

					//, 'fullscreenchange'
					['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function (name) {
						document[_addEventListener](name, throttledCheckElements, true);
					});

					if (/d$|^c/.test(document.readyState)) {
						onload();
					} else {
						addEventListener('load', onload);
						document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
						setTimeout(onload, 20000);
					}

					if (lazysizes.elements.length) {
						checkElements();
						rAF._lsFlush();
					} else {
						throttledCheckElements();
					}
				},
				checkElems: throttledCheckElements,
				unveil: unveilElement
			};
		}();

		var autoSizer = function () {
			var autosizesElems;

			var sizeElement = rAFIt(function (elem, parent, event, width) {
				var sources, i, len;
				elem._lazysizesWidth = width;
				width += 'px';

				elem.setAttribute('sizes', width);

				if (regPicture.test(parent.nodeName || '')) {
					sources = parent.getElementsByTagName('source');
					for (i = 0, len = sources.length; i < len; i++) {
						sources[i].setAttribute('sizes', width);
					}
				}

				if (!event.detail.dataAttr) {
					updatePolyfill(elem, event.detail);
				}
			});
			var getSizeElement = function getSizeElement(elem, dataAttr, width) {
				var event;
				var parent = elem.parentNode;

				if (parent) {
					width = getWidth(elem, parent, width);
					event = triggerEvent(elem, 'lazybeforesizes', { width: width, dataAttr: !!dataAttr });

					if (!event.defaultPrevented) {
						width = event.detail.width;

						if (width && width !== elem._lazysizesWidth) {
							sizeElement(elem, parent, event, width);
						}
					}
				}
			};

			var updateElementsSizes = function updateElementsSizes() {
				var i;
				var len = autosizesElems.length;
				if (len) {
					i = 0;

					for (; i < len; i++) {
						getSizeElement(autosizesElems[i]);
					}
				}
			};

			var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

			return {
				_: function _() {
					autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
					addEventListener('resize', debouncedUpdateElementsSizes);
				},
				checkElems: debouncedUpdateElementsSizes,
				updateElem: getSizeElement
			};
		}();

		var init = function init() {
			if (!init.i) {
				init.i = true;
				autoSizer._();
				loader._();
			}
		};

		lazysizes = {
			cfg: lazySizesConfig,
			autoSizer: autoSizer,
			loader: loader,
			init: init,
			uP: updatePolyfill,
			aC: addClass,
			rC: removeClass,
			hC: hasClass,
			fire: triggerEvent,
			gW: getWidth,
			rAF: rAF
		};

		return lazysizes;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109)(module)))

/***/ }),

/***/ 185:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var focusHelper = __webpack_require__(177);

	/**
	 * Parses the html for a modal window
	 * @param {string} html - representing the body and footer of the modal window
	 *
	 * @return {Object} - Object with properties body and footer.
	 */
	function parseHtml(html) {
	    var $html = $('<div>').append($.parseHTML(html));

	    var body = $html.find('.choice-of-bonus-product');
	    var footer = $html.find('.modal-footer').children();

	    return {
	        body: body,
	        footer: footer
	    };
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @param {Object} data - data object used to fill in dynamic portions of the html
	 */
	function chooseBonusProducts(data) {
	    $('.modal-body').spinner().start();

	    if ($('#chooseBonusProductModal').length !== 0) {
	        $('#chooseBonusProductModal').remove();
	    }
	    var bonusUrl;
	    if (data.bonusChoiceRuleBased) {
	        bonusUrl = data.showProductsUrlRuleBased;
	    } else {
	        bonusUrl = data.showProductsUrlListBased;
	    }

	    var htmlString = '<!-- Modal -->' + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog choose-bonus-product-dialog" ' + 'data-total-qty="' + data.maxBonusItems + '"' + 'data-UUID="' + data.uuid + '"' + 'data-pliUUID="' + data.pliUUID + '"' + 'data-addToCartUrl="' + data.addToCartUrl + '"' + 'data-pageStart="0"' + 'data-pageSize="' + data.pageSize + '"' + 'data-moreURL="' + data.showProductsUrlRuleBased + '"' + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '    <span class="">' + data.labels.selectprods + '</span>' + '    <button type="button" class="close pull-right" data-dismiss="modal">' + '        <span aria-hidden="true">&times;</span>' + '        <span class="sr-only"> </span>' + '    </button>' + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer"></div>' + '</div>' + '</div>' + '</div>';
	    $('body').append(htmlString);
	    $('.modal-body').spinner().start();

	    $.ajax({
	        url: bonusUrl,
	        method: 'GET',
	        dataType: 'json',
	        success: function success(response) {
	            var parsedHtml = parseHtml(response.renderedTemplate);
	            $('#chooseBonusProductModal .modal-body').empty();
	            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
	            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
	            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
	            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
	            $('#chooseBonusProductModal').modal('show');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	module.exports = {

	    methods: {
	        editBonusProducts: function editBonusProducts(data) {
	            chooseBonusProducts(data);
	        }
	    },

	    chooseBonusProducts: chooseBonusProducts,

	    focusChooseBonusProductModal: function focusChooseBonusProductModal() {
	        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
	            $('#chooseBonusProductModal .close').focus();
	        });
	    },

	    onClosingChooseBonusProductModal: function onClosingChooseBonusProductModal() {
	        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
	        });
	    },

	    trapChooseBonusProductModalFocus: function trapChooseBonusProductModalFocus() {
	        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
	            var focusParams = {
	                event: e,
	                containerSelector: '#chooseBonusProductModal',
	                firstElementSelector: '.close',
	                lastElementSelector: '.add-bonus-products'
	            };
	            focusHelper.setTabNextFocus(focusParams);
	        });
	    },

	    selectBonusProduct: function selectBonusProduct() {
	        $(document).on('click', '.select-bonus-product', function () {
	            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
	            var pid = $(this).data('pid');
	            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
	            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
	            var totalQty = 0;
	            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
	                totalQty += $(this).data('qty');
	            });
	            totalQty += submittedQty;
	            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
	            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
	            if (totalQty <= maxPids) {
	                var selectedBonusProductHtml = '' + '<div class="selected-pid row" ' + 'data-pid="' + pid + '"' + 'data-qty="' + submittedQty + '"' + 'data-optionID="' + (optionID || '') + '"' + 'data-option-selected-value="' + (valueId || '') + '"' + '>' + '<div class="col-sm-11 col-9 bonus-product-name" >' + $choiceOfBonusProduct.find('.product-name').html() + '</div>' + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>' + '</div>';
	                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
	                $('.pre-cart-products').html(totalQty);
	                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	            } else {
	                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
	            }
	        });
	    },
	    removeBonusProduct: function removeBonusProduct() {
	        $(document).on('click', '.selected-pid', function () {
	            $(this).remove();
	            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
	            var count = 0;
	            if ($selected.length) {
	                $selected.each(function () {
	                    count += parseInt($(this).data('qty'), 10);
	                });
	            }

	            $('.pre-cart-products').html(count);
	            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	        });
	    },
	    enableBonusProductSelection: function enableBonusProductSelection() {
	        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
	            $('button.select-bonus-product', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);
	            var pid = response.product.id;
	            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
	        });
	    },
	    showMoreBonusProducts: function showMoreBonusProducts() {
	        $(document).on('click', '.show-more-bonus-products', function () {
	            var url = $(this).data('url');
	            $('.modal-content').spinner().start();
	            $.ajax({
	                url: url,
	                method: 'GET',
	                success: function success(html) {
	                    var parsedHtml = parseHtml(html);
	                    $('.modal-body').append(parsedHtml.body);
	                    $('.show-more-bonus-products:first').remove();
	                    $('.modal-content').spinner().stop();
	                },
	                error: function error() {
	                    $('.modal-content').spinner().stop();
	                }
	            });
	        });
	    },
	    addBonusProductsToCart: function addBonusProductsToCart() {
	        $(document).on('click', '.add-bonus-products', function () {
	            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
	            var queryString = '?pids=';
	            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
	            var pidsObject = {
	                bonusProducts: []
	            };

	            $.each($readyToOrderBonusProducts, function () {
	                var qtyOption = parseInt($(this).data('qty'), 10);

	                var option = null;
	                if (qtyOption > 0) {
	                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
	                        option = {};
	                        option.optionId = $(this).data('optionid');
	                        option.productId = $(this).data('pid');
	                        option.selectedValueId = $(this).data('option-selected-value');
	                    }
	                    pidsObject.bonusProducts.push({
	                        pid: $(this).data('pid'),
	                        qty: qtyOption,
	                        options: [option]
	                    });
	                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
	                }
	            });
	            queryString += JSON.stringify(pidsObject);
	            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
	            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
	            $.spinner().start();
	            $.ajax({
	                url: url + queryString,
	                method: 'POST',
	                success: function success(data) {
	                    $.spinner().stop();
	                    if (data.error) {
	                        $('#chooseBonusProductModal').modal('hide');
	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center"' + ' role="alert">' + data.errorMessage + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                        }, 3000);
	                    } else {
	                        $('.configure-bonus-product-attributes').html(data);
	                        $('.bonus-products-step2').removeClass('hidden-xl-down');
	                        $('#chooseBonusProductModal').modal('hide');

	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.minicart-quantity').html(data.totalQty);
	                        setTimeout(function () {
	                            if ($('.cart-page').length) {
	                                location.reload();
	                            }
	                        }, 1500);
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        });
	    }
	};

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var base = __webpack_require__(182),
	    bonusProductHelpers = __webpack_require__(185),
	    detectDevice = __webpack_require__(198);

	function sizeIsSelectedFunc($elem) {
	    var isDisabled = $elem.data('is-disabled');
	    var isOneSizePLP = $elem.parents('.cc-content-button').prev('.color-swatches').find('.select-size').length <= 0;
	    var isOneSizePDP = $elem.parents('.pdp-col-description').find('.container-size-list').length <= 0;

	    if ((isDisabled === true || isDisabled === 'true') && (!isOneSizePLP || !isOneSizePDP)) {
	        // if button is disabled and prod is not a oneSize prod, no msg hint'll be shown
	        var $hintPdp = $elem.parents('.product-detail').find('.availability-msg .availability-msg-hint');
	        var $hintPlp = $elem.parents('.container-tile-hover').find('.availability-msg .availability-msg-hint');
	        var $hint = $hintPdp.add($hintPlp);
	        $hint.removeClass('d-none');
	        var hintText = $hint.text().trim();
	        var $liveRegion = $('<div aria-live="assertive" aria-atomic="true" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;"></div>').appendTo('body');
	        setTimeout(function () {
	            $liveRegion.text(hintText);
	            setTimeout(function () {
	                $liveRegion.remove();
	            }, 1000);
	        }, 100);
	        return false;
	    } else {
	        return true;
	    }
	}

	/**
	 * Retrieve product options
	 *
	 * @param {jQuery} $productContainer - DOM element for current product
	 * @return {string} - Product options and their selected values
	 */
	function getOptions($productContainer) {
	    var options = $productContainer.find('.product-option').map(function () {
	        var $elOption = $(this).find('.options-select');
	        var urlValue = $elOption.val();
	        var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
	        return {
	            optionId: $(this).data('option-id'),
	            selectedValueId: selectedValueId
	        };
	    }).toArray();

	    return JSON.stringify(options);
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @return {string} - The provided URL to use when adding a product to the cart
	 */
	function getAddToCartUrl() {
	    return $('.add-to-cart-url').val();
	}

	/**
	 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
	 * items with their selected variants
	 *
	 * @return {string[]} - List of selected bundle product item ID's
	 */
	function getChildProducts() {
	    var childProducts = [];
	    $('.bundle-item').each(function () {
	        childProducts.push({
	            pid: $(this).find('.product-id').text(),
	            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
	        });
	    });

	    return childProducts.length ? JSON.stringify(childProducts) : [];
	}

	/**
	 * Retrieve contextual quantity selector
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {jquery} - quantity selector DOM container
	 */
	function getQuantitySelector($el) {
	    return $el && $('.set-items').length ? $($el).closest('.product-detail').find('.quantity-select') : $('.quantity-select');
	}

	/**
	 * Retrieves the value associated with the Quantity pull-down menu
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {string} - value found in the quantity input
	 */
	function getQuantitySelected($el) {
	    return getQuantitySelector($el).val();
	}

	/**
	 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
	 * @param {string} response - ajax response from clicking the add to cart button
	 */
	function handlePostCartAdd(response) {
	    $('.minicart').trigger('count:update', response);

	    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
	        bonusProductHelpers.chooseBonusProducts(response.newBonusDiscountLineItem);
	    }
	}

	function showMiniCart(reportingURL) {
	    return new $.Deferred(function (deferred) {
	        base.miniCartReportingUrl(reportingURL);
	        $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	        var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	        if (minicartTimeout > 0) {
	            setTimeout(function () {
	                if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                    $('#closeMiniCartButton').click();
	                    $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                    deferred.resolve();
	                }

	                if ($('.js-header').hasClass('cc-header__tag__viewHeader') && window.isDesktop) {
	                    $('.js-header').removeClass('cc-header__tag__viewHeader');

	                    // Check if we're on brandHomepage
	                    var isBrandHomepage = $('.cc-brandHomepage').length > 0;

	                    if (isBrandHomepage) {
	                        // For brandHomepage, reset miniCart and intro positioning
	                        $('.cc-minicart-overlay').css('top', '');
	                        $('.experience-commerce_layouts-intro').css('top', '-1px');
	                    } else {
	                        // For PLP pages, use existing cleanup logic
	                        var $breadcrumbContainer = $('.js-breadcrumbContainer');
	                        var $filterWrapper = $('.cc-plp--filters--sticky');
	                        var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	                        var $categoryWrapperInner = $('.js-categoryPills');
	                        var $categoryWrapper = $('.cc-plp--categories--sticky');
	                        var heightFilter = 52;
	                        var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	                        $breadcrumbContainer.css('top', 0);
	                        if ($categoryWrapperInner.length > 0) {
	                            $categoryWrapper.css('top', 42 - breadcrumbHeigth);
	                            $filterWrapper.css('top', 117 + logoHeight - breadcrumbHeigth);
	                        } else {
	                            if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                                $filterWrapper.css('top', 0);
	                            } else {
	                                $filterWrapper.css('top', heightFilter - breadcrumbHeigth);
	                            }
	                        }
	                    }
	                }
	            }, minicartTimeout);
	        }
	    }).promise();
	}

	module.exports = {
	    addToCart: function addToCart() {
	        $('.container').on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            e.stopImmediatePropagation();

	            var addToCartUrl;
	            var pid;
	            var pidsObj;
	            var setPids;

	            var $self = $(this);

	            var sizeIsSelected = sizeIsSelectedFunc($self);
	            if (!sizeIsSelected) {
	                return;
	            }

	            $('body').trigger('product:beforeAddToCart', this);

	            if ($('.set-items').length && $self.hasClass('add-to-cart-global')) {
	                setPids = [];

	                $('.product-detail').each(function () {
	                    if (!$self.hasClass('product-set-detail')) {
	                        setPids.push({
	                            pid: $self.find('.product-id').text(),
	                            qty: $self.find('.quantity-select').val(),
	                            options: getOptions($self)
	                        });
	                    }
	                });
	                pidsObj = JSON.stringify(setPids);
	            }

	            pid = base.getPidValue($self);

	            var $productContainer = $self.closest('.product-detail');
	            if (!$productContainer.length) {
	                $productContainer = $self.closest('.quick-view-dialog').find('.product-detail');
	            }

	            addToCartUrl = getAddToCartUrl();

	            var form = {
	                pid: pid,
	                pidsObj: pidsObj,
	                childProducts: getChildProducts(),
	                quantity: getQuantitySelected($self) || 1
	            };

	            if ($('body').hasClass('checkOutPage')) {
	                form.checkOutPage = true;
	            }

	            if (!$('.bundle-item').length) {
	                form.options = getOptions($productContainer);
	            }

	            //IN-AR TRY ON
	            var tryOnButton = $('.js-tryOn-button'),
	                dataEvent = {};

	            if (tryOnButton && tryOnButton.length > 0) {
	                var tryOnDesktopClick = 'false',
	                    tryOnMobileRedirect = 'false';
	                //If the device is Mobile/Tablet we will have the info of the Try-on usage in a specific div
	                if (detectDevice.detectMobile()) {
	                    tryOnMobileRedirect = $('.try-on-redirected').attr('data-used-try-on');
	                }
	                //If the device is Desktop we will have the info of the Try-on button clicked in the button itself
	                else {
	                        if (tryOnButton.length > 0) {
	                            tryOnDesktopClick = $('.js-tryOn-button').attr('data-ga-cliked');
	                        }
	                    }

	                form.tryOnDesktopClick = tryOnDesktopClick;
	                form.tryOnMobileRedirect = tryOnMobileRedirect;
	            }

	            // Analytics data
	            $('body').trigger('analytics:addToCartSubmitting', form);

	            $(this).trigger('updateAddToCartFormData', form);
	            if (addToCartUrl) {
	                $.ajax({
	                    url: addToCartUrl,
	                    method: 'POST',
	                    data: form,
	                    success: function success(data) {
	                        if (data.limitMessage || data.unavailableItemAdded) {
	                            $('#cartLimit-modal-body').text(data.limitMessage || '');
	                            $('#cartLimit-modal').modal('show');
	                            $.spinner().stop();
	                        } else {
	                            //normal behavior
	                            handlePostCartAdd(data);
	                            //update the minicart price total
	                            $('.js-header').removeClass('cc-header__tag__scrollDown');
	                            if ($('.minicartIconPrice').length > 0) {
	                                $('.minicartIconPrice').html(data.cart.totals.subTotal);
	                            }
	                            $('#analytics-cartInfo').data('value', data.cart && data.cart.totals && data.cart.totals.grandTotalDecimal);
	                            $('#analytics-cartInfo').data('couponsName', data.cart && data.cart.couponNamesString);
	                            $('body').trigger('product:afterAddToCart', data);

	                            //analytics event
	                            dataEvent.productID = pid;
	                            if (tryOnButton && tryOnButton.length > 0) {
	                                dataEvent.tryOnDesktopClick = tryOnDesktopClick;
	                                dataEvent.tryOnMobileRedirect = tryOnMobileRedirect;
	                            }

	                            $('body').trigger('analytics:addToCart', dataEvent);

	                            $.spinner().stop();
	                            base.miniCartReportingUrl(data.reportingURL);
	                            $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	                            var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	                            // if (minicartTimeout > 0) {
	                            //     setTimeout(function() {
	                            //         if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                            //             //close minicart only of is opened automatically from pdp or plp or wishlist
	                            //             $('#closeMiniCartButton').click();
	                            //             $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                            //         }
	                            //     }, minicartTimeout);
	                            // }

	                            var isCartPage = $('.cc-cart-container');

	                            showMiniCart(data.reportingURL).then(function () {
	                                if (isCartPage.length > 0) {
	                                    window.location.reload();
	                                }
	                            });
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }
	};

/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	"use strict";

	/**
	 * A function that detects user's device.
	 * @returns {Boolean} Returns `true` if user's device is mobile/tablet.
	 */
	function detectMobile() {
	    var toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

	    return toMatch.some(function (toMatchItem) {
	        return navigator.userAgent.match(toMatchItem);
	    });
	}

	module.exports = {
	    detectMobile: detectMobile
	};

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

	'use strict';

	/**
	 * appends params to a url
	 * @param {string} url - Original url
	 * @param {Object} params - Parameters to append
	 * @returns {string} result url with appended parameters
	 */

	function appendToUrl(url, params) {
	    var newUrl = url;
	    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
	        return key + '=' + encodeURIComponent(params[key]);
	    }).join('&');

	    return newUrl;
	}

	module.exports = {
	    addAndRemoveToWishlist: function addAndRemoveToWishlist() {
	        $('.container').on('click', '.add-to-wish-list', function (e) {
	            // Mobile users are redirect to size selection if no size is chosen
	            var reminderSizeSelectHint = document.querySelector('.js-reminder-hint');
	            if (reminderSizeSelectHint && window.innerWidth <= 768) {
	                reminderSizeSelectHint.scrollIntoView({
	                    behavior: 'smooth',
	                    block: 'center'
	                });
	            }

	            e.stopPropagation();
	            e.preventDefault();
	            e.stopImmediatePropagation();
	            // TODO: migrate to require('../utils/authState').isAuthenticated()
	            var loggedin = $('.js-userIcon').length > 0 ? true : false;

	            var addUrl = $(this).data('add-href');
	            var removeUrl = $(this).data('remove-href');
	            var button = $(this);
	            var buttonContentAdd = $(this).find('.wishlist-content-add');
	            var buttonContentRemove = $(this).find('.wishlist-content-remove');
	            var pid = $(this).closest('.product-tile').find('.add-to-cart').attr('data-pid') || $(this).closest('.product-detail').attr('data-pid') || $(this).attr('data-pid');
	            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
	            var sizeOptionValue = $('#size-ul-list li.selected').data('attr-value');
	            if (!sizeOptionValue) {
	                sizeOptionValue = $(this).data('is-size-selected');
	            }
	            var optionValueColor = $('.color-attribute').data('color');
	            if (!optionValueColor) {
	                optionValueColor = $(this).parent().find('a .active').parent().attr('data-color');
	            }
	            var cleanSizeOptionValue = $('#size-ul-list li.selected').data('display-value');

	            optionId = optionId || null;
	            sizeOptionValue = sizeOptionValue || null;
	            removeUrl = removeUrl + '?pid=' + pid;

	            if (!addUrl || !removeUrl || !pid) {
	                return;
	            }

	            var isRedirectToLogin = false;
	            if (!loggedin) {
	                // Assigning hardcoded values for guests. Optional values (on bags) don't interfere
	                var urlParams = {
	                    rurl: 4,
	                    pid: pid,
	                    oid: 'size',
	                    oval: sizeOptionValue,
	                    cleanSizeValue: cleanSizeOptionValue,
	                    oidcol: 'color',
	                    ovalcol: optionValueColor
	                };

	                addUrl = appendToUrl(addUrl, urlParams);
	            }

	            if (button.hasClass('to-add') || button.attr('data-variation-group') === 'to-add') {
	                //analytics add to wishlist event
	                $('body').trigger('analytics:addToWishlist', pid);

	                $.spinner().start();
	                $.ajax({
	                    url: addUrl,
	                    type: 'post',
	                    dataType: 'json',
	                    data: {
	                        pid: pid,
	                        optionId: optionId,
	                        optionVal: sizeOptionValue
	                    },
	                    success: function success(data) {
	                        //see Wishlist-AddProduct
	                        if (isRedirectToLogin) {
	                            isRedirectToLogin = false;
	                            if (data.redirectUrl) {
	                                window.location.href = data.redirectUrl;
	                            }
	                            return;
	                        }
	                        if (data.success) {
	                            buttonContentAdd.addClass('d-none');
	                            buttonContentRemove.removeClass('d-none');
	                            button.removeClass('to-add').addClass('to-remove');
	                            button.attr('aria-label', button.data('aria-remove'));
	                            // Value to blacken the heart icon
	                            window.ProductsInWishlist = data.wishlistSize;

	                            // Wishlist minicart will be called after the sucessful adding of the item to the wishlist
	                            $('body').trigger('product:afterAddToWishlist', data);

	                            $('.js-tileWrapper').removeClass('js-tileWrapperHover');
	                            $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	                            // After adding the product to the wishlist, set the data-variation-group to "to-remove"
	                            button.attr('data-variation-group', 'to-remove');
	                        } else {
	                            if (data.isFull) {
	                                $('#wishlist-modal-body').text(data.maxProductsMessage);
	                                $('#wishlist-modal').modal('show');
	                            }
	                        }
	                        if (!data.isFull) {
	                            window.ProductsInWishlist = data.productsArr;
	                            var counter = parseInt(data.wishlistSize);
	                            if (counter > 0) {
	                                $('.js-wishlistNumber').removeClass('d-none');
	                            }
	                            $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                        }

	                        if ($('[data-action="Search-Show"]').length > 0) {
	                            $('.js-header').removeClass('cc-header__tag__scrollDown');
	                        }
	                        $.spinner().stop();

	                        // After the wishlist minicart is displayed, if it was opened automatically, it will close after a timeout.
	                        $('.js-minicart-wishlist-overlay').addClass('js-opened-by-add-to-minicart');
	                        var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));
	                        if (minicartTimeout > 0) {
	                            setTimeout(function () {
	                                if ($('.cc-minicart-overlay').hasClass('js-opened-by-add-to-minicart')) {
	                                    //close minicart only of is opened automatically from pdp or plp or wishlist
	                                    $('#closeMiniWishlistCartButton').click();
	                                    $('.cc-minicart-overlay').removeClass('js-opened-by-add-to-minicart');
	                                }
	                            }, minicartTimeout);
	                        }
	                    },
	                    error: function error(err) {
	                        $.spinner().stop();
	                        var redirectUrl = err && err.responseJSON && err.responseJSON.redirectUrl;
	                        if (redirectUrl) {
	                            window.location.href = redirectUrl;
	                        }
	                    }
	                });
	            } else if (button.hasClass('to-remove') || button.attr('data-variation-group') === 'to-remove') {
	                //analytics remove from wishlist event
	                $('body').trigger('analytics:removeFromWishlist', pid);

	                $.spinner().start();
	                $.ajax({
	                    url: removeUrl,
	                    type: 'get',
	                    dataType: 'json',
	                    data: {},
	                    success: function success(data) {
	                        //see Wishlist-RemoveProduct
	                        $.spinner().stop();
	                        buttonContentAdd.removeClass('d-none');
	                        buttonContentRemove.addClass('d-none');
	                        button.removeClass('to-remove').addClass('to-add');
	                        button.attr('aria-label', button.data('aria-add'));
	                        //------------------------------
	                        window.ProductsInWishlist = data.productsArr;
	                        var counter = parseInt(data.wishlistSize);
	                        if (counter > 0) {
	                            $('.js-wishlistNumber').removeClass('d-none');
	                        }
	                        $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                        // After removing the product from the wishlist, set the data-variation-group to "to-add"
	                        button.attr('data-variation-group', 'to-add');
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }
	};

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// var base = require('./base');

	var focusHelper = __webpack_require__(177);

	/**
	 * Generates the modal window on the first call.
	 *
	 */
	function getModalHtmlElement() {
	    if ($('#quickViewModal').length !== 0) {
	        $('#quickViewModal').remove();
	    }
	    var htmlString = '<!-- Modal -->' + '<div class="modal fade" id="quickViewModal" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog quick-view-dialog">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '<a class="full-pdp-link" href=""></a>' + '<button type="button" class="close pull-right" data-dismiss="modal">' + '<span aria-hidden="true">&times;</span>' + '<span class="sr-only"> </span>' + '</button>' + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer"></div>' + '</div>' + '</div>' + '</div>';
	    $('body').append(htmlString);
	}

	/**
	 * @typedef {Object} QuickViewHtml
	 * @property {string} body - Main Quick View body
	 * @property {string} footer - Quick View footer content
	 */

	/**
	 * Parse HTML code in Ajax response
	 *
	 * @param {string} html - Rendered HTML from quickview template
	 * @return {QuickViewHtml} - QuickView content components
	 */
	function parseHtml(html) {
	    var $html = $('<div>').append($.parseHTML(html));

	    var body = $html.find('.product-quickview');
	    var footer = $html.find('.modal-footer').children();

	    return { body: body, footer: footer };
	}

	/**
	 * replaces the content in the modal window on for the selected product variation.
	 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
	 */
	function fillModalElement(selectedValueUrl) {
	    $('.modal-body').spinner().start();
	    $.ajax({
	        url: selectedValueUrl,
	        method: 'GET',
	        dataType: 'json',
	        success: function success(data) {
	            var parsedHtml = parseHtml(data.renderedTemplate);

	            $('.modal-body').empty();
	            $('.modal-body').html(parsedHtml.body);
	            $('.modal-footer').html(parsedHtml.footer);
	            $('.full-pdp-link').text(data.quickViewFullDetailMsg);
	            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
	            $('#quickViewModal .size-chart').attr('href', data.productUrl);
	            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
	            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
	            $('#quickViewModal').modal('show');
	            $('body').trigger('quickview:ready');

	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	module.exports = {
	    showQuickview: function showQuickview() {
	        $('body').on('click', '.quickview', function (e) {
	            e.preventDefault();
	            var selectedValueUrl = $(this).closest('a.quickview').attr('href');
	            $(e.target).trigger('quickview:show');
	            getModalHtmlElement();
	            fillModalElement(selectedValueUrl);
	        });
	    },
	    focusQuickview: function focusQuickview() {
	        $('body').on('shown.bs.modal', '#quickViewModal', function () {
	            $('#quickViewModal .close').focus();
	        });
	    },
	    trapQuickviewFocus: function trapQuickviewFocus() {
	        $('body').on('keydown', '#quickViewModal', function (e) {
	            var focusParams = {
	                event: e,
	                containerSelector: '#quickViewModal',
	                firstElementSelector: '.full-pdp-link',
	                lastElementSelector: '.add-to-cart-global',
	                nextToLastElementSelector: '.modal-footer .quantity-select'
	            };
	            focusHelper.setTabNextFocus(focusParams);
	        });
	    },
	    // availability: base.availability,
	    // addToCart: base.addToCart,
	    showSpinner: function showSpinner() {
	        $('body').on('product:beforeAddToCart', function (e, data) {
	            $(data).closest('.modal-content').spinner().start();
	        });
	    },
	    hideDialog: function hideDialog() {
	        $('body').on('product:afterAddToCart', function () {
	            $('#quickViewModal').modal('hide');
	        });
	    },
	    beforeUpdateAttribute: function beforeUpdateAttribute() {
	        $('body').on('product:beforeAttributeSelect', function () {
	            $('.modal.show .modal-content').spinner().start();
	        });
	    },
	    updateAttribute: function updateAttribute() {
	        $('body').on('product:afterAttributeSelect', function (e, response) {
	            if ($('.modal.show .product-quickview>.bundle-items').length) {
	                $('.modal.show').find(response.container).data('pid', response.data.product.id);
	                $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
	            } else if ($('.set-items').length) {
	                response.container.find('.product-id').text(response.data.product.id);
	            } else {
	                $('.modal.show .product-quickview').data('pid', response.data.product.id);
	                $('.modal.show .full-pdp-link').attr('href', response.data.product.selectedProductUrl);
	            }
	        });
	    },
	    updateAddToCart: function updateAddToCart() {
	        $('body').on('product:updateAddToCart', function (e, response) {
	            // update local add to cart (for sets)
	            $('button.add-to-cart', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);

	            // update global add to cart (single products, bundles)
	            var dialog = $(response.$productContainer).closest('.quick-view-dialog');

	            $('.add-to-cart-global', dialog).attr('disabled', !$('.global-availability', dialog).data('ready-to-order') || !$('.global-availability', dialog).data('available'));
	        });
	    },
	    updateAvailability: function updateAvailability() {
	        $('body').on('product:updateAvailability', function (e, response) {
	            // bundle individual products
	            $('.product-availability', response.$productContainer).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available).find('.availability-msg').empty().html(response.message);

	            var dialog = $(response.$productContainer).closest('.quick-view-dialog');

	            if ($('.product-availability', dialog).length) {
	                // bundle all products
	                var allAvailable = $('.product-availability', dialog).toArray().every(function (item) {
	                    return $(item).data('available');
	                });

	                var allReady = $('.product-availability', dialog).toArray().every(function (item) {
	                    return $(item).data('ready-to-order');
	                });

	                $('.global-availability', dialog).data('ready-to-order', allReady).data('available', allAvailable);

	                $('.global-availability .availability-msg', dialog).empty().html(allReady ? response.message : response.resources.info_selectforstock);
	            } else {
	                // single product
	                $('.global-availability', dialog).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available).find('.availability-msg').empty().html(response.message);
	            }
	        });
	    }
	};

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

	var tileHelper = __webpack_require__(321);
	var lastClickedFilterId = null;
	var lastClickedFilterValue = null;
	var lastFocusedElementSelector = null;
	var lastFocusedFilterIdentifier = null;

	/**
	 * Fill the slider of the price filter with the correct color/values
	 *
	 * @param {Object} from - jQuery DOM element
	 * @param {Object} to - jQuery DOM element
	 * @param {string} sliderColor - color of the slider
	 * @param {string} rangeColor - color of the range
	 * @param {Object} controlSlider - jQuery DOM element
	 */
	function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
	    var rangeDistance = to.max - to.min;
	    var fromPosition = from.value - to.min;
	    var toPosition = to.value - to.min;
	    controlSlider.style.background = 'linear-gradient(\n      to right,\n      ' + sliderColor + ' 0%,\n      ' + sliderColor + ' ' + fromPosition / rangeDistance * 100 + '%,\n      ' + rangeColor + ' ' + fromPosition / rangeDistance * 100 + '%,\n      ' + rangeColor + ' ' + toPosition / rangeDistance * 100 + '%,\n      ' + sliderColor + ' ' + toPosition / rangeDistance * 100 + '%,\n      ' + sliderColor + ' 100%)';
	}

	/**
	 * Return the range for the price filter
	 *
	 * @param {Object} currentFrom - jQuery DOM element
	 * @param {Object} currentTo - jQuery DOM element
	 * @return {Array} - array with the from and to values
	 */
	function getParsed(currentFrom, currentTo) {
	    var from = parseInt(currentFrom.value, 10);
	    var to = parseInt(currentTo.value, 10);
	    return [from, to];
	}

	/**
	 * Set the z-index of the toggle slider
	 *
	 * @param {Object} currentTarget - jQuery DOM element
	 */
	function setToggleAccessible(currentTarget) {
	    var toSlider = document.querySelector('#toSlider');
	    if (Number(currentTarget.value) <= 0) {
	        toSlider.style.zIndex = 2;
	    } else {
	        toSlider.style.zIndex = 0;
	    }
	}

	/**
	 * Fill the slider if client use the from input
	 *
	 * @param {Object} fromSlider - jQuery DOM element
	 * @param {Object} fromInput - jQuery DOM element
	 * @param {Object} toInput - jQuery DOM element
	 * @param {Object} controlSlider - jQuery DOM element
	 */
	function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
	    var _getParsed = getParsed(fromInput, toInput),
	        _getParsed2 = _slicedToArray(_getParsed, 2),
	        from = _getParsed2[0],
	        to = _getParsed2[1];

	    if (from > to) {
	        from = to;
	    }

	    fromSlider.value = from;
	    fromInput.value = from;
	    var toSlider = document.querySelector('#toSlider');

	    fillSlider(fromInput, toSlider, '#E7E6DD', '#000', controlSlider);
	    setToggleAccessible(fromSlider);
	}

	/**
	 * Fill the slider if client use the to input
	 *
	 * @param {Object} toSlider - jQuery DOM element
	 * @param {Object} fromInput - jQuery DOM element
	 * @param {Object} toInput - jQuery DOM element
	 * @param {Object} controlSlider - jQuery DOM element
	 */
	function controlToInput(toSlider, fromInput, toInput, controlSlider) {
	    var _getParsed3 = getParsed(fromInput, toInput),
	        _getParsed4 = _slicedToArray(_getParsed3, 2),
	        from = _getParsed4[0],
	        to = _getParsed4[1];

	    if (to < from) {
	        to = from;
	    }

	    toSlider.value = to;
	    toInput.value = to;

	    fillSlider(fromInput, toSlider, '#E7E6DD', '#000', controlSlider);
	    setToggleAccessible(toSlider);
	}

	/**
	 * Fill the slider if client use the from slider
	 *
	 * @param {Object} fromSlider - jQuery DOM element
	 * @param {Object} toSlider - jQuery DOM element
	 * @param {Object} fromInput - jQuery DOM element
	 */
	function controlFromSlider(fromSlider, toSlider, fromInput) {
	    var _getParsed5 = getParsed(fromSlider, toSlider),
	        _getParsed6 = _slicedToArray(_getParsed5, 2),
	        from = _getParsed6[0],
	        to = _getParsed6[1];

	    var oldMinPrice = $('.js-filterPrice').attr('data-old-min-price');

	    if (from === to) {
	        if (Number(oldMinPrice) === to) {
	            from = from - 1;
	        } else {
	            to = to + 1;
	        }
	    }

	    fillSlider(fromSlider, toSlider, '#E7E6DD', '#000', toSlider);
	    if (from > to) {
	        fromSlider.value = to;
	        fromInput.value = to;
	    } else {
	        fromInput.value = from;
	    }
	}

	/**
	 * Fill the slider if client use the to slider
	 *
	 * @param {Object} fromSlider - jQuery DOM element
	 * @param {Object} toSlider - jQuery DOM element
	 * @param {Object} fromInput - jQuery DOM element
	 */
	function controlToSlider(fromSlider, toSlider, toInput) {
	    var _getParsed7 = getParsed(fromSlider, toSlider),
	        _getParsed8 = _slicedToArray(_getParsed7, 2),
	        from = _getParsed8[0],
	        to = _getParsed8[1];

	    fillSlider(fromSlider, toSlider, '#E7E6DD', '#000', toSlider);
	    setToggleAccessible(toSlider);
	    if (from <= to) {
	        toSlider.value = to;
	        toInput.value = to;
	    } else {
	        toInput.value = from;
	        toSlider.value = from;
	    }
	}

	function changeInput() {
	    var fromSlider = document.querySelector('#fromSlider');
	    var toSlider = document.querySelector('#toSlider');
	    var fromInput = document.querySelector('#fromInput');
	    var toInput = document.querySelector('#toInput');

	    if (!fromSlider || !toSlider || !fromInput || !toInput) {
	        return;
	    }

	    if (event.target === fromInput) {
	        controlFromInput(fromSlider, fromInput, toInput, toSlider);
	    }
	    if (event.target === toInput) {
	        controlToInput(toSlider, fromInput, toInput, toSlider);
	    }
	}

	/**
	 * Update the browser's history (the price refinement is automatically calculated in this function)
	 *
	 * @param {string} url - the url which will be used for next state
	 * @param {string} urlRedirect - the url's search params
	 */
	function pushFilterUrlState(url, urlRedirect) {
	    var params = urlRedirect;
	    var nextURL = window.origin + params;
	    url = window.origin + url;
	    // Current URL + params size page and total count
	    var nextTitle = document.title;
	    var nextState = {
	        urlRefinement: url,
	        urlRedirectRefinement: url
	    };
	    history.pushState(nextState, nextTitle, nextURL);
	}

	/**
	 * Update the link[rel="canonical"] URL
	 *
	 * @param {string} params
	 */
	function pushCanonialUrlState(params) {
	    var nextURL = window.origin + params;
	    $('link[rel="canonical"]').attr('href', nextURL);
	}

	/**
	 * Update DOM elements with Ajax results
	 *
	 * @param {Object} $results - jQuery DOM element
	 * @param {string} selector - DOM element to look up in the $results
	 * @return {undefined}
	 */
	function updateDom($results, selector) {
	    var $updates = $results.find(selector);

	    $(selector).empty().html($updates.html());

	    if (selector === '.refreshableCategoryRefinements' || selector === '.js-categoryfilterbar' || selector === '.js-activeFilter') {
	        $('.js-activeCategoryFilter').html($('.cc-plp--categoryItem--selected').html());
	    }
	}

	function updateHeadDom($results, selector) {
	    var $updates = $results.filter(selector);
	    $(selector).empty().html($updates.html());
	}

	/**
	 * Keep refinement panes expanded/collapsed after Ajax refresh
	 *
	 * @param {Object} $results - jQuery DOM element
	 * @return {undefined}
	 */
	function handleRefinements($results) {
	    $('.refinement.active').each(function () {
	        $(this).removeClass('active');
	        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
	        activeDiv.addClass('active');
	        activeDiv.find('button.title').attr('aria-expanded', 'true');
	    });

	    updateDom($results, '.refinements');

	    //category filter bar for mobile
	    var categoryFilterBarSelector = '.js-categoryfilterbar';
	    updateDom($results, categoryFilterBarSelector);

	    setTimeout(function () {
	        if ($('.js-categoryPills').length === 0) {
	            $('.js-categoryfilterbar').addClass('d-none');
	        } else {
	            $('.js-categoryfilterbar').addClass('d-block');
	        }

	        if ($('.cc-plp--scrollCategories').length > 0) {
	            var catScrollWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].scrollWidth;
	            var catOffsetWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].offsetWidth;

	            if (catScrollWidth > catOffsetWidth) {
	                $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	            }
	        }
	    }, 0);
	}

	/**
	 * Update the URL with the sortoption and replace the current history state
	 *
	 * @param {string} sortSelected - id of the current sort option selected
	 * @return {undefined}
	 */
	function updateUrlWithSortOption(sortSelected) {
	    var currUrl = new URL(location.href);
	    if (sortSelected !== 'bs-title-option') {
	        if (location.href.includes('srule')) {
	            currUrl.searchParams.delete('srule');
	            currUrl.searchParams.append('srule', sortSelected);
	        } else {
	            currUrl.searchParams.append('srule', sortSelected);
	        }
	    }
	    // New URL informations + params size page and total count
	    var nextURL = currUrl;
	    var nextTitle = document.title;
	    var nextState = {
	        id: sortSelected
	    };
	    // This will replace the current entry in the browser's history, without reloading
	    history.replaceState(nextState, nextTitle, nextURL);
	}

	/**
	 * Parse the result retrieved from the backend'ajax call, also reinitiate the category carousel
	 *
	 * @param {string} response - the entire plp refreshed, with the new DOM use to update
	 */
	// eslint-disable-next-line complexity
	function parseResults(response) {
	    var nameDropdownOpened = void 0;
	    var mobileMenuOpened = $('.cc-plp--filterModal.show').length > 0;
	    var filterScrollPosition = 0;

	    //if a third/fourth category is selected, remove the "show all" link
	    if ($('.cc-plp--filterDropdown.show').length > 0) {
	        nameDropdownOpened = $('.cc-plp--filterDropdown.show').attr('name');
	    }

	    if ($('.cc-plp--filterDropdown.cc-plp--filterDropdown--open').length > 0) {
	        nameDropdownOpened = $('.cc-plp--filterDropdown.cc-plp--filterDropdown--open').attr('name');

	        // Save scroll position before update filter
	        if (mobileMenuOpened && $(window).width() < 1201) {
	            var $filterDropdown = $('.cc-plp--filterDropdown[name="' + nameDropdownOpened + '"]');
	            var $scrollContainer = $filterDropdown.find('.cc-plp--filterDropdown--items');

	            if ($scrollContainer.length > 0) {
	                filterScrollPosition = $scrollContainer.scrollTop();
	            }
	        }
	    }

	    var storedFocusedFilter = sessionStorage.getItem('plp_lastFocusedFilter');
	    if (storedFocusedFilter && mobileMenuOpened) {
	        nameDropdownOpened = storedFocusedFilter;
	        lastFocusedFilterIdentifier = storedFocusedFilter;
	        sessionStorage.removeItem('plp_lastFocusedFilter');
	    }

	    //globalThis.PREV_CONDITION;
	    var $results = $(response);
	    var specialHandlers = {
	        '.refinements': handleRefinements
	    };

	    // Update DOM elements in head
	    updateHeadDom($results, 'title');

	    // Update DOM elements that do not require special handling
	    var BLOCK_TO_UPDATE = ['.refreshableSEOCategoryDesc', '.refreshableCategoryRefinements', '.product-grid', '.show-more', '.js-activeFilter', '.js-filterUpdate', '.js-editorialSpace-top', '.js-editorialSpace-bottom', '.js-categoryTitleSection', '.js-categoryfilterbar', '.js-breadcrumbContainer', '.cc-search-result-count'];
	    //new logic to let open the sub filter opened

	    for (var i = 0; i < BLOCK_TO_UPDATE.length; i++) {
	        var selector = BLOCK_TO_UPDATE[i];
	        updateDom($results, selector);

	        // Restore scroll position after filter update on mobile
	        if (selector === '.js-filterUpdate' && mobileMenuOpened && $(window).width() < 1201 && filterScrollPosition > 0 && typeof nameDropdownOpened !== 'undefined') {
	            requestAnimationFrame(function () {
	                var $filterDropdown = $('.cc-plp--filterDropdown[name="' + nameDropdownOpened + '"]');
	                var $scrollContainer = $filterDropdown.find('.cc-plp--filterDropdown--items');

	                if ($scrollContainer.length > 0) {
	                    $scrollContainer.scrollTop(filterScrollPosition);
	                }
	            });
	        }
	    }
	    $('.selectpicker').selectpicker('refresh');
	    Object.keys(specialHandlers).forEach(function (selector) {
	        specialHandlers[selector]($results);
	    });

	    if (typeof nameDropdownOpened !== 'undefined') {
	        if (mobileMenuOpened) {
	            // Mobile: only add mobile-specific classes
	            $('body').addClass('modal-open');
	            $('.cc-plp--filters--sticky').css({ position: 'relative', 'z-index': 'unset' });
	            $('.cc-plp--filterModal').addClass('show').css('display', 'block');
	            $('.cc-submenu-voice.position-relative').addClass('d-none');

	            var $dropdown = $('.cc-plp--filterDropdown[name="' + nameDropdownOpened + '"]');
	            $dropdown.addClass('cc-plp--filterDropdown--open');
	            $dropdown.closest('.cc-submenu-voice').removeClass('d-none');

	            $('.js-dropdownFilterMobile[data-refinement-trigger="' + nameDropdownOpened + '"]').addClass('cc-plp--filterRow--item--active');

	            if (nameDropdownOpened !== 'sorting') {
	                $('.cc-plp--filterDropdown--sortingLabel').addClass('d-none');
	            }
	        } else {
	            // Desktop: add desktop-specific classes
	            $('.cc-plp--filterDropdown[name="' + nameDropdownOpened + '"]').addClass('show');
	            $('.cc-plp--filterDropdown[name="' + nameDropdownOpened + '"]').closest('.cc-submenu-voice').find('.js-dropdownFilter').attr('aria-expanded', 'true');
	        }
	    }

	    //register the impressions of the new products loaded
	    $('body').trigger('analytics:productsLoaded');

	    setTimeout(function () {
	        if ($('.js-categoryPills').length === 0) {
	            $('.js-categoryfilterbar').removeClass('d-block').addClass('d-none');
	        } else {
	            $('.js-categoryfilterbar').removeClass('d-none').addClass('d-block');
	        }
	    }, 0);

	    if ($('.cc-plp--scrollCategories').length > 0) {
	        var catScrollWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].scrollWidth;
	        var catOffsetWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].offsetWidth;

	        if (catScrollWidth > catOffsetWidth) {
	            $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	        }
	    }

	    if ($('.js-breadcrumbContainer .cc-breadcrumb--container').height() === 0) {
	        $('.js-breadcrumbContainer').removeClass('cc-breadcrumb--container__wrapper--sticky');
	    } else {
	        $('.js-breadcrumbContainer').addClass('cc-breadcrumb--container__wrapper--sticky');
	    }

	    var fromSlider = document.querySelector('#fromSlider');
	    var toSlider = document.querySelector('#toSlider');

	    if (fromSlider && toSlider) {
	        fillSlider(fromSlider, toSlider, '#E7E6DD', '#000', toSlider);
	        setToggleAccessible(toSlider);
	    }

	    if ($('.cc-plp--filterWrapper div').length === 0) {
	        $('.cc-plp--filters--sticky').css('display', 'none');
	    } else {
	        $('.cc-plp--filters--sticky').css('display', 'block');
	    }
	}

	/**
	 * Update sort option URLs from Ajax response
	 *
	 * @param {string} response - Ajax response HTML code
	 * @return {undefined}
	 */
	function updateSortOptions(response) {
	    var $tempDom = $('<div>').append($(response));
	    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
	    sortOptions.forEach(function (option) {
	        $('option.' + option.id).val(option.url);
	    });
	}

	function modifyUrlAfterShowMore() {
	    var $loadMoreButton = $('.show-more button');

	    var urlFinal = function urlFinal() {
	        var urlShowMore = $loadMoreButton.data('url');
	        var sizeResult = '',
	            urlResult = '',
	            start,
	            sz;

	        try {
	            var urlParams = new URL(urlShowMore);
	            start = urlParams.searchParams.get('start');
	            sz = urlParams.searchParams.get('sz');
	        } catch (e) {
	            start = null;
	            sz = null;
	        }

	        if (start && sz) {
	            sizeResult = parseInt(start) + parseInt(sz);
	        }

	        try {
	            var locationHref = new URL(window.location.href);
	            locationHref.searchParams.set('start', 0);
	            locationHref.searchParams.set('sz', sizeResult);
	            urlResult = locationHref.toString();
	        } catch (e) {
	            start = null;
	            sz = null;
	        }

	        return urlResult;
	    };

	    // Current URL + params size page and total count
	    var nextURL = urlFinal();
	    var nextTitle = document.title;
	    var idValue = $('.refreshableCategoryRefinements .values div a.cc-current-category').attr('id');
	    var nextState = {
	        id: idValue
	    };

	    // This will replace the current entry in the browser's history, without reloading
	    history.replaceState(nextState, nextTitle, nextURL);
	}

	//This function checks after load more button in PLP if there are variant to handle
	function isInWishlistAfterLoadMore() {
	    var productArr = window.ProductsInWishlist;
	    if (!productArr) {
	        return;
	    }

	    $('.product-grid .column-tile .product.product-tile').each(function () {
	        var pid = $(this).data('pid');
	        if (productArr.length > 0 && productArr.indexOf(pid) > -1) {
	            tileHelper.handleWishlistButtonInTile($(this), true);
	        } else {
	            tileHelper.handleWishlistButtonInTile($(this), false);
	        }
	    });
	}

	function loadContentShowMore(e) {
	    var $loadMoreButton = $('.show-more button');

	    if (!$loadMoreButton.length) {
	        return;
	    }
	    var showMoreUrl = $loadMoreButton.data('url');
	    $.spinner().start();
	    $loadMoreButton.trigger('search:showMore', e);
	    $.ajax({
	        url: showMoreUrl,
	        data: {
	            selectedUrl: showMoreUrl
	        },
	        method: 'GET',
	        success: function success(response) {
	            $loadMoreButton.removeClass('d-none');
	            modifyUrlAfterShowMore();
	            var scrollPosition = $(window).scrollTop();
	            $('.grid-footer').replaceWith(response);
	            $(window).scrollTop(scrollPosition);

	            // Constructor analytics: propagate result_id to newly loaded tiles
	            var cnstrcResultId = $('.cc-product-grid').attr('data-cnstrc-result-id');
	            if (cnstrcResultId) {
	                $('.cc-column-tile:not([data-cnstrc-result-id])').attr('data-cnstrc-result-id', cnstrcResultId);
	            }

	            updateSortOptions(response);
	            isInWishlistAfterLoadMore();
	            $.spinner().stop();
	            if ($('.cc-more-col').hasClass('active')) {
	                $('.cc-column-tile').addClass('cc-col-tile-more');
	            } else {
	                $('.cc-column-tile').removeClass('cc-col-tile-more');
	            }

	            $('.cc-label-clubprice').addClass('icon-bata-club-price-cz');

	            //register the impressions of the new products loaded
	            $('body').trigger('analytics:productsLoaded');

	            // const numberItemPerPage = $('.cc-load-more-container-mobile').data('items-per-page');
	            // const numberItemVisibleNow = $('.js-numberOfItems').text();
	            // const totalOfItems = $('.cc-load-more-container-mobile').data('total-products');
	            // const totalItemVisible = parseInt(numberItemPerPage) + parseInt(numberItemVisibleNow);
	            // const itemsVisible = (totalItemVisible > totalOfItems) ? totalOfItems : totalItemVisible;
	            var itemsVisible = $('.js-numberOfItems').data('product-in-page');
	            $('.js-numberOfItems').text(itemsVisible);
	        },
	        error: function error() {
	            $loadMoreButton.removeClass('d-none');
	            $.spinner().stop();
	        }
	    });
	}

	/**
	 * Restore focus to the last clicked filter after AJAX reload (accessibility)
	 */
	function restoreFocusAfterAjax() {
	    if (!lastClickedFilterId || !lastClickedFilterValue) {
	        return;
	    }

	    setTimeout(function () {
	        var selector = '.js-sorting-link[data-refinement-id="' + lastClickedFilterId + '"][data-refinement-value="' + lastClickedFilterValue + '"]';
	        var $sortingLink = $(selector);

	        if ($sortingLink.length) {
	            var isModalOpen = $('.cc-plp--filterModal.show').length > 0;

	            if (isModalOpen) {
	                var $modalLink = $('#filterModal').find(selector);
	                if ($modalLink.length) {
	                    $modalLink[0].focus();
	                }
	            } else {
	                var $sortingDropdown = $('#sortingDropdown');
	                if ($sortingDropdown.length) {
	                    $sortingDropdown.attr('aria-expanded', 'false');
	                    $('.cc-plp--filterDropdown.show').removeClass('show');
	                    requestAnimationFrame(function () {
	                        return $sortingDropdown[0].focus();
	                    });
	                }
	            }
	        } else {
	            var $filter = $('.js-applyFilter[data-refinement-id="' + lastClickedFilterId + '"][data-refinement-value="' + lastClickedFilterValue + '"]');
	            if ($filter.length) {
	                $filter[0].focus();
	            }
	        }
	    }, 100);
	}

	function updateContainerShowAjax(element, e, urlDataHref) {
	    $.spinner().start();

	    if (element && $(element).hasClass('js-applyFilter')) {
	        lastClickedFilterId = $(element).data('refinement-id');
	        lastClickedFilterValue = $(element).data('refinement-value');
	    } else if (element && $(element).hasClass('js-sorting-link')) {
	        lastClickedFilterId = $(element).data('refinement-id');
	        lastClickedFilterValue = $(element).data('refinement-value');
	    }

	    if (element) {
	        $(element).trigger('search:filter', e);
	    } else if (urlDataHref) {
	        $('[data-href="' + urlDataHref + '"]').trigger('search:filter', e);
	    }
	    // Acquire the pathname of the category that needs to be accessed and update the attribute, in order to
	    // use it into the destinationUrl variable below.
	    $('.js-parentCategoryPathName').attr('data-href', window.location.pathname);
	    var destinationUrl = $(element).data('href') || urlDataHref;
	    // If the targeting element is recognized as null, use the target href.
	    var finalUrl;
	    if (element === null) {
	        finalUrl = e.target.location.href;
	    } else {
	        // In all other cases of recognition, do the default functionality.
	        finalUrl = destinationUrl;
	    }

	    if (!finalUrl) {
	        return;
	    }

	    $.ajax({
	        url: finalUrl,
	        data: {
	            page: $('.grid-footer').data('page-number'),
	            selectedUrl: finalUrl
	        },
	        method: 'GET',
	        success: function success(response) {
	            parseResults(response);

	            if ($('.cc-plp--filters--sticky').attr('data-new-min-price')) {
	                $('#fromSlider').val($('.cc-plp--filters--sticky').attr('data-new-min-price'));
	                $('#fromInput').val($('.cc-plp--filters--sticky').attr('data-new-min-price'));
	            }

	            if ($('.cc-plp--filters--sticky').attr('data-new-max-price')) {
	                $('#toSlider').val($('.cc-plp--filters--sticky').attr('data-new-max-price'));
	                $('#toInput').val($('.cc-plp--filters--sticky').attr('data-new-max-price'));
	            }

	            var fromSlider = document.querySelector('#fromSlider');
	            var toSlider = document.querySelector('#toSlider');

	            if (fromSlider && toSlider) {
	                fillSlider(fromSlider, toSlider, '#E7E6DD', '#000', toSlider);
	                setToggleAccessible(toSlider);
	            }

	            if ($('.cc-plp--filterDropdown--sortingLabel [aria-expanded="true"]').length > 0) {
	                $('.cc-plp--filterDropdown--sortingLabel .js-dropdownFilter').trigger('click');
	            }

	            $([document.documentElement, document.body]).animate({
	                scrollTop: 0
	            }, 300);

	            restoreFocusAfterAjax();

	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	/* ON SCROLL ANIMATION */
	var lastScroll = 0;
	window.addEventListener('scroll', function () {
	    if ($('.cc-minicart-overlay').hasClass('show') || $('[data-action="Search-Show"]').length === 0) {
	        return;
	    }

	    var $breadcrumbContainer = $('.js-breadcrumbContainer');
	    var $categoryWrapper = $('.cc-plp--categories--sticky');
	    var $categoryWrapperInner = $('.js-categoryPills');
	    var $filterWrapper = $('.cc-plp--filters--sticky');
	    var currentScroll = $(this).scrollTop();
	    var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	    var documentHeight = $(document).height();
	    var windowHeight = $(window).height();
	    var bottomOffset = 30; // Tolleranza per il controllo della fine della pagina
	    var $onTopBtn = $('.js-toTopButton');
	    var heightFilter = 52;
	    var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	    // Controllo se siamo vicini alla fine della pagina
	    if (currentScroll + windowHeight >= documentHeight - bottomOffset) {
	        return;
	    }

	    if (currentScroll > lastScroll && currentScroll > 10) {
	        $breadcrumbContainer.css('top', 0);
	        if ($categoryWrapperInner.length > 0) {
	            $categoryWrapper.css('top', 44 - breadcrumbHeigth);
	            $filterWrapper.css('top', 117 + logoHeight - breadcrumbHeigth);
	        } else {
	            if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                $filterWrapper.css('top', 0);
	            } else {
	                $filterWrapper.css('top', heightFilter - breadcrumbHeigth);
	            }
	        }
	    } else {
	        $breadcrumbContainer.css('top', 0);
	        if ($categoryWrapperInner.length > 0) {
	            $categoryWrapper.css('top', 44 - breadcrumbHeigth);
	            $filterWrapper.css('top', 117 + logoHeight - breadcrumbHeigth);
	        } else {
	            if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                $filterWrapper.css('top', 0);
	            } else {
	                $filterWrapper.css('top', heightFilter - breadcrumbHeigth);
	            }
	        }
	    }

	    lastScroll = currentScroll;

	    if (currentScroll > 200) {
	        $onTopBtn.addClass('cc-plp--toTopBtn--show');
	    } else {
	        $onTopBtn.removeClass('cc-plp--toTopBtn--show');
	    }
	}, { passive: true });

	$('#backInStockModal').on('show.bs.modal', function () {
	    document.querySelector('.backinstock-body').style.display = 'block';
	    document.querySelector('.serviceMessage').style.display = 'none';
	});

	module.exports = {
	    popstate: function popstate() {
	        //this is triggered when is used the back button of the browser
	        //to show in ajax the category content or refinemect applied
	        $(window).on('popstate', function (e) {
	            var state = e.originalEvent.state || {};
	            var selectedCategoryId = state.id;
	            var urlRefinement = state.urlRefinement;
	            var urlRedirectRefinement = state.urlRedirectRefinement;
	            if (selectedCategoryId) {
	                var target = $('[data-category-id="' + selectedCategoryId + '"]');
	                if (target.length) {
	                    updateContainerShowAjax(target, e);
	                }
	            } else if (urlRefinement && urlRedirectRefinement) {
	                updateContainerShowAjax(null, e, urlRefinement);
	            } else {
	                updateContainerShowAjax(null, e, urlRefinement);
	            }
	        });
	    },
	    updateCategoryElementsAfterClickSideCategory: function updateCategoryElementsAfterClickSideCategory() {
	        $('.container').on('click', '.js-categoryItem', function (e) {
	            e.preventDefault();
	            e.stopPropagation();

	            $('.js-categoryItem').removeClass('cc-plp--categoryItem--selected');
	            $(this).removeClass('cc-plp--categoryItems--viewChild').addClass('cc-plp--categoryItem--selected');

	            var categoryTitle = $('.js-categoryItem.cc-plp--categoryItem--selected').attr('data-category-title');

	            $('.js-categoryName').html(categoryTitle);
	            // This will replace the current entry in the browser's history, without reloading
	            //history.replaceState(nextState, nextTitle, nextURL);
	        });
	    },
	    refreshPLPTile: tileHelper.refreshPLPTile,
	    sort: function sort() {
	        function applySorting($sortingLink, e) {
	            var $sortSelected = $sortingLink.closest('.js-sorting-sub-option');
	            if (!$sortSelected.length) {
	                return;
	            }

	            $.spinner().start();
	            var sortId = $sortSelected.data('id');
	            var sortName = $sortSelected.data('name');

	            lastClickedFilterId = sortId;
	            lastClickedFilterValue = sortName;

	            $('.js-sorting-sub-option .js-sorting-link').removeClass('active-filter').attr('aria-checked', 'false');
	            $sortingLink.addClass('active-filter').attr('aria-checked', 'true');

	            $('.js-sorting-menu-selected').text($sortingLink.text()).attr('data-value', $sortingLink.text());

	            $('body').trigger('analytics:updateProductSorting', { sorting: sortName });

	            if (sortId) {
	                updateUrlWithSortOption(sortId);
	                updateContainerShowAjax($sortingLink[0], e);
	            }
	        }

	        $(document).on('click', '.js-sorting-sub-option .js-sorting-link', function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            applySorting($(this), e);
	        });

	        $('.container').on('keydown', '.js-sorting-link', function (e) {
	            if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
	                e.preventDefault();
	                e.stopPropagation();
	                e.stopImmediatePropagation();
	                applySorting($(this), e);
	                return false;
	            }
	        });
	    },
	    showMore: function showMore() {
	        // Show more products
	        $('.container').on('click', '.show-more button', function (e) {
	            e.stopPropagation();
	            e.preventDefault();

	            loadContentShowMore(e);
	        });
	    },
	    //this handles all the refinements (category, sorting and filters)
	    applyFilter: function applyFilter() {
	        $('.container').on('click', '.js-categoryItem, .js-resetRefinement, .js-applyFilter, .js-removeFilter', function (e) {
	            e.preventDefault();
	            e.stopPropagation();

	            var $refinement = $(this);
	            var url = $refinement.data('href'),
	                urlRedirect = $refinement.attr('href');

	            if ($refinement.hasClass('js-resetPriceRefinement') || $refinement.hasClass('js-resetRefinement')) {
	                $('.cc-plp--filters--sticky').removeAttr('data-new-min-price').removeAttr('data-new-max-price');
	            }

	            if (lastFocusedFilterIdentifier && $('.cc-plp--filterModal.show').length) {
	                sessionStorage.setItem('plp_lastFocusedFilter', lastFocusedFilterIdentifier);
	            }

	            pushFilterUrlState(url, urlRedirect);
	            pushCanonialUrlState(urlRedirect);
	            updateContainerShowAjax(this, e, null);
	        });

	        // category filters in search page (they have to behave with XOR logic)
	        $('.container').on('click', '.js-searchCategoryList .values div a', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            var $category = $(this);
	            var $container = $category.closest('.js-searchCategoryList');
	            var $elements = $container.find('.values div.cc-filter-category');
	            $elements.removeClass('cc-current-category');
	            updateContainerShowAjax(this, e, null);
	            $category.closest('div.cc-filter-category').addClass('cc-current-category');
	        });
	    },
	    backInStock: function backInStock() {
	        $('.backinstock-form').submit(function (e) {
	            var form = $(this);
	            e.preventDefault();
	            var url = form.attr('action');
	            form.spinner().start();
	            var button = $('#submitEmailButton');

	            if (button.length && button.data('id') && button.data('message')) {
	                var buttonData = {
	                    id: button.data('id'),
	                    message: button.data('message')
	                };
	                $('body').trigger('analytics:clickBackInStock', buttonData);
	            }

	            $.ajax({
	                url: url,
	                type: 'post',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    form.spinner().stop();
	                    if (data.success) {
	                        document.querySelector('.backinstock-body').style.display = 'none';
	                        $('.serviceMessage').empty().append($('<p>', { class: 'cc-service-message--text', text: data.receivedMsgBody }), $('<div>', {
	                            class: 'cc-content-button-back',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close'
	                        }).append($('<a>', { href: '', class: 'cc-link-type-2', id: 'submitEmailButton', text: data.buttonText })));
	                        document.querySelector('.serviceMessage').style.display = 'block';
	                        form[0].reset();
	                    } else if (!data.success) {
	                        document.querySelector('.backinstock-body').style.display = 'none';
	                        $('.serviceMessage').empty().append($('<p>', { class: 'cc-service-message--text', text: data.receivedMsgBody }), $('<div>', {
	                            class: 'cc-content-button-back',
	                            'data-dismiss': 'modal',
	                            'aria-label': 'Close'
	                        }).append($('<a>', { href: '', class: 'cc-link-type-2', id: 'submitEmailButton', text: data.buttonText })));
	                        document.querySelector('.serviceMessage').style.display = 'block';
	                        form[0].reset();
	                    }
	                },
	                error: function error() {
	                    form.spinner().stop();
	                }
	            });
	        });
	    },
	    addToCart: tileHelper.addToCart
	};

	//Move the mobile category filter in the correct position and initialize the category carousel
	$(function () {
	    tileHelper.productsInWishlistOnDOMready();
	    //this function sets the state for the browser back button logic content loaded in Ajax
	    //(see function updateCategoryElementsAfterClickSideCategory() )
	    var idValue = $('.refreshableCategoryRefinements .values a.cc-plp--categoryItem--selected').attr('data-category-id'); // Try to find the attribute of the category shown on page refresh
	    var nextState = {
	        id: idValue
	    };
	    history.replaceState(nextState, null, null);

	    var $categoryFilterBar = $('.js-categoryfilterbar');
	    $categoryFilterBar.appendTo('.js-categoryFiltersContainer');
	    //if a third/fourth category is selected, remove the "show all" link
	    if ($categoryFilterBar.find('.js-categorySelected').length) {
	        $categoryFilterBar.find('.js-mainCategory').remove();
	    }

	    if ($('.cc-plp--scrollCategories').length > 0) {
	        var catScrollWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].scrollWidth;
	        var catOffsetWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].offsetWidth;

	        if (catScrollWidth > catOffsetWidth) {
	            $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	        }
	    }

	    if ($('.js-breadcrumbContainer .cc-breadcrumb--container').height() === 0) {
	        $('.js-breadcrumbContainer').removeClass('cc-breadcrumb--container__wrapper--sticky');
	    } else {
	        $('.js-breadcrumbContainer').addClass('cc-breadcrumb--container__wrapper--sticky');
	    }
	});

	$(document).on('click', '.js-dropdownFilter', function (e) {
	    e.preventDefault();
	    e.stopPropagation();

	    var $self = $(this);
	    var $dropdown = $self.closest('.cc-submenu-voice').find('.cc-plp--filterDropdown');
	    var dropdownName = $dropdown.attr('name');

	    if ($self.attr('aria-expanded') === 'false') {
	        $('.js-dropdownFilter').attr('aria-expanded', 'false');
	        $('.js-dropdownFilter').closest('.cc-submenu-voice').find('.cc-plp--filterDropdown').removeClass('show');

	        $self.attr('aria-expanded', 'true');
	        $dropdown.addClass('show');

	        lastFocusedFilterIdentifier = dropdownName;

	        setTimeout(function () {
	            // eslint-disable-next-line no-use-before-define
	            var $focusable = getFocusableElements($dropdown);
	            if ($focusable.length) {
	                $focusable.first().focus();
	            }
	        }, 50);
	    } else {
	        $self.attr('aria-expanded', 'false');
	        $dropdown.removeClass('show');
	        lastFocusedFilterIdentifier = null;
	    }
	});

	$(document).on('click', '.cc-plp', function () {
	    if ($('.js-dropdownFilter').attr('aria-expanded') === 'false') {
	        $('.js-dropdownFilter').attr('aria-expanded', 'false');
	        $('.js-dropdownFilter').closest('.dropdown').find('.dropdown-menu').removeClass('show');
	    }
	});

	$('.container').on('click', '.js-openAccordion', function () {
	    var $self = $(this);
	    var accordionName = $self.data('open-accordion');

	    lastFocusedFilterIdentifier = accordionName;

	    if (accordionName === 'sorting') {
	        $('.cc-plp--filterRow--list').addClass('d-none');
	        $('.cc-plp--filterDropdown--sortingLabel').removeClass('d-none');
	    } else {
	        $('.cc-plp--filterRow--list').removeClass('d-none');
	        $('.cc-plp--filterDropdown--sortingLabel').addClass('d-none');
	    }

	    $('.cc-plp--filterDropdown').removeClass('cc-plp--filterDropdown--open');
	    $('.cc-plp--filterDropdown').closest('.cc-submenu-voice').addClass('d-none');
	    $('.cc-plp--filterDropdown[name="' + accordionName + '"]').addClass('cc-plp--filterDropdown--open').closest('.cc-submenu-voice').removeClass('d-none');
	    $('.cc-plp--filterRow--item').removeClass('cc-plp--filterRow--item--active');
	    $('.cc-plp--filterRow--item[data-refinement-trigger="' + accordionName + '"]').addClass('cc-plp--filterRow--item--active');
	});

	$('.container').on('click', '.js-dropdownFilterMobile', function () {
	    var $self = $(this);
	    var accordionName = $self.data('refinement-trigger');

	    lastFocusedFilterIdentifier = accordionName;

	    if (accordionName === 'sorting') {
	        $('.cc-plp--filterRow--list').addClass('d-none');
	        $('.cc-plp--filterDropdown--sortingLabel').removeClass('d-none');
	    } else {
	        $('.cc-plp--filterRow--list').removeClass('d-none');
	        $('.cc-plp--filterDropdown--sortingLabel').addClass('d-none');
	    }

	    $('.cc-plp--filterDropdown').removeClass('cc-plp--filterDropdown--open');
	    $('.cc-plp--filterDropdown').closest('.cc-submenu-voice').addClass('d-none');
	    $('.cc-plp--filterDropdown[name="' + accordionName + '"]').addClass('cc-plp--filterDropdown--open').closest('.cc-submenu-voice').removeClass('d-none');
	    $('.cc-plp--filterRow--item').removeClass('cc-plp--filterRow--item--active');
	    $('.cc-plp--filterRow--item[data-refinement-trigger="' + accordionName + '"]').addClass('cc-plp--filterRow--item--active');

	    setTimeout(function () {
	        var $openDropdown = $('.cc-plp--filterDropdown.cc-plp--filterDropdown--open');
	        if ($openDropdown.length) {
	            // eslint-disable-next-line no-use-before-define
	            var $focusable = getFocusableElements($openDropdown);
	            if ($focusable.length) {
	                $focusable.first().focus();
	            }
	        }
	    }, 100);
	});

	$(window).on('resize', function () {
	    if (!window.isMobile) {
	        // FSP-40499: The loginDrawerModal might be present in multiple parts of the site.
	        // The backdrop modal should stay if the login portal is still opened while the window is resized.
	        if (!$('#loginDrawerModal').hasClass('show')) {
	            $('.modal-backdrop').remove();
	        }
	        $('body').removeClass('modal-open');
	        $('.cc-plp--filterModal').css('display', 'flex');
	        $('.js-breadcrumbContainer').removeAttr('style');
	        $('.cc-plp--categories--sticky').removeAttr('style');
	        $('.cc-plp--filters--sticky').removeAttr('style');
	        $('.cc-submenu-voice').removeClass('d-none');

	        if ($('.cc-plp--filterModal').hasClass('show')) {
	            $('.cc-plp--filterDropdown--sortingLabel').removeClass('d-none');
	            $('.cc-plp--filterModal').removeClass('show');
	        }

	        if ($('.cc-plp--scrollCategories').length > 0) {
	            var catScrollWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].scrollWidth;
	            var catOffsetWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].offsetWidth;

	            if (catScrollWidth > catOffsetWidth) {
	                $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	            }
	        }
	    }
	});

	$('.container').on('hidden.bs.modal', '#filterModal', function () {
	    $('.cc-plp--filters--sticky').css({ position: 'sticky', 'z-index': '3' });
	});

	$('.container').on('shown.bs.modal', '#filterModal', function () {
	    $('.cc-plp--filters--sticky').css({ position: 'relative', 'z-index': 'unset' });

	    if (!lastFocusedElementSelector) {
	        return;
	    }

	    var accordionName = $(lastFocusedElementSelector).data('open-accordion');
	    if (!accordionName) {
	        return;
	    }

	    requestAnimationFrame(function () {
	        var $openDropdown = $('.cc-plp--filterDropdown.cc-plp--filterDropdown--open[name="' + accordionName + '"]');
	        if ($openDropdown.length) {
	            var $firstFocusable = void 0;

	            // For price filter, find the first input
	            if ($openDropdown.hasClass('js-filterPriceDropdown')) {
	                $firstFocusable = $openDropdown.find('.js-minPriceFilter').first();
	                if (!$firstFocusable.length) {
	                    $firstFocusable = $openDropdown.find('input[type="number"]').first();
	                }
	            }
	            // For sorting, find .js-sorting-link
	            else if (accordionName === 'sorting') {
	                    $firstFocusable = $openDropdown.find('.js-sorting-link').first();
	                }
	                // For other filters, find .js-applyFilter
	                else {
	                        $firstFocusable = $openDropdown.find('.js-applyFilter').first();
	                    }

	            if ($firstFocusable.length) {
	                requestAnimationFrame(function () {
	                    $firstFocusable[0].focus();
	                });
	                return;
	            }
	        }

	        // Fallback to modal button if no filter found
	        var $mobileButton = $('.cc-plp--filterModal--containerMobile button.js-dropdownFilterMobile[data-refinement-trigger="' + accordionName + '"]');
	        if ($mobileButton.length) {
	            requestAnimationFrame(function () {
	                $mobileButton[0].focus();
	            });
	        }
	    });
	});

	$(document).on('click', function (e) {
	    e.stopPropagation();

	    var $categoryModal = $('.cc-plp--categories--dropdown');

	    if (!$categoryModal.length > 0 || !($categoryModal.length > 0 && $categoryModal.hasClass('cc-plp--categories--dropdown--open')) || $(e.target).prop('class') === 'cc-plp--categoryItem' || $(e.target).closest('.cc-plp--categories--dropdown--open').length > 0) {
	        return;
	    }

	    $categoryModal.removeClass('cc-plp--categories--dropdown--open');
	});

	$(document).on('click', function (e) {
	    e.stopPropagation();

	    var $filterModal = $('.cc-plp--filterDropdown');

	    if (!$filterModal.length > 0 || !($filterModal.length > 0 && $filterModal.hasClass('show')) || $(e.target).prop('class') === 'filterModal' || $(e.target).closest('.filterModal').length > 0) {
	        return;
	    }

	    $filterModal.removeClass('show').closest('.cc-submenu-voice').find('.cc-plp--filterRow--item').attr('aria-expanded', 'false');
	});

	$('.container').on('click', '.js-categoryBtn', function () {
	    $(this).closest('.cc-plp--categories--dropdown').toggleClass('cc-plp--categories--dropdown--open');
	});

	$('.container').on('click', '.js-closeDropdownFilter', function (e) {
	    e.preventDefault();
	    e.stopPropagation();

	    var $self = $(this);

	    if (window.isDesktop) {
	        $self.closest('.cc-submenu-voice').find('.cc-plp--filterRow--item').attr('aria-expanded', 'false');
	        $self.closest('.cc-plp--filterDropdown').removeClass('show');
	    } else {
	        // On mobile, close the entire modal (not just the dropdown)
	        // This button is used to apply filters and close the modal
	        // eslint-disable-next-line no-use-before-define
	        closeModalAndRestoreFocus();
	    }
	});

	$('.container').on('click', '.cc-plp--filterModal', function (e) {
	    if (!window.isMobile || $(e.target).prop('class') === 'cc-plp--filterModal--content' || $(e.target).closest('.cc-plp--filterModal--content').length > 0) {
	        return;
	    }

	    $('.cc-plp--filterModal').toggle('modal');
	    $('body').removeClass('modal-open');
	    $('.cc-plp--filterModal').removeClass('show');
	    $('.modal-backdrop').remove();
	    $('.cc-plp--filters--sticky').css({ position: 'sticky', 'z-index': '3' });
	});

	$('.container').on('click', '.js-scrollLeft', function () {
	    $('.cc-plp--scrollCategories').animate({
	        scrollLeft: $('.cc-plp--scrollCategories').scrollLeft() - 100
	    }, 300);

	    var currentLeftPos = $('.cc-plp--categoryItem:first-child').offset().left;

	    if ($('.cc-plp--filters--brandLogo').length > 0 && currentLeftPos > 94 || $('.cc-plp--filters--brandLogo').length === 0 && currentLeftPos > 0) {
	        $('.js-scrollLeftWrapper').addClass('cc-plp--hideBtn');
	    } else {
	        $('.js-scrollLeftWrapper').removeClass('cc-plp--hideBtn');
	    }

	    $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	});

	$('.container').on('click', '.js-scrollRight', function () {
	    $('.cc-plp--scrollCategories').animate({
	        scrollLeft: $('.cc-plp--scrollCategories').scrollLeft() + 100
	    }, 300);

	    $('.js-scrollLeftWrapper').removeClass('cc-plp--hideBtn');

	    var currentLeftPos = $('.cc-plp--categoryItem:first-child').offset().left;

	    var catScrollWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].scrollWidth;
	    var catOffsetWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].offsetWidth;

	    if (catOffsetWidth - currentLeftPos + 30 >= catScrollWidth) {
	        $('.js-scrollRightWrapper').addClass('cc-plp--hideBtn');
	    } else {
	        $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	    }
	});

	$('.cc-plp--scrollCategories').on('scroll', function () {
	    var currentLeftPos = $('.cc-plp--categoryItem:first-child').offset().left;
	    var catScrollWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].scrollWidth;
	    var catOffsetWidth = document.getElementsByClassName('cc-plp--scrollCategories')[0].offsetWidth;

	    if (catOffsetWidth - currentLeftPos + 30 >= catScrollWidth) {
	        $('.js-scrollRightWrapper').addClass('cc-plp--hideBtn');
	    } else {
	        $('.js-scrollRightWrapper').removeClass('cc-plp--hideBtn');
	    }

	    if ($('.cc-plp--filters--brandLogo').length > 0 && currentLeftPos > 94 || $('.cc-plp--filters--brandLogo').length === 0 && currentLeftPos > 0) {
	        $('.js-scrollLeftWrapper').addClass('cc-plp--hideBtn');
	    } else {
	        $('.js-scrollLeftWrapper').removeClass('cc-plp--hideBtn');
	    }
	});

	$('.container').on('click', '.js-filterPriceDropdown', function (e) {
	    e.preventDefault();
	    e.stopPropagation();
	});

	var urlParams = new URLSearchParams(window.location.search);
	var minPriceFilter = urlParams.get('pmin');
	var maxPriceFilter = urlParams.get('pmax');

	if (minPriceFilter) {
	    $('#fromSlider').val(parseInt(minPriceFilter));
	    $('#fromInput').val(parseInt(minPriceFilter));
	}
	if (maxPriceFilter) {
	    $('#toSlider').val(parseInt(maxPriceFilter));
	    $('#toInput').val(parseInt(maxPriceFilter));
	}

	var fromSlider = document.querySelector('#fromSlider');
	var toSlider = document.querySelector('#toSlider');
	var fromInput = document.querySelector('#fromInput');
	var toInput = document.querySelector('#toInput');

	if (fromSlider && toSlider && fromInput && toInput) {
	    fillSlider(fromSlider, toSlider, '#E7E6DD', '#000', toSlider);
	    setToggleAccessible(toSlider);

	    fromSlider.oninput = function () {
	        return controlFromSlider(fromSlider, toSlider, fromInput);
	    };
	    toSlider.oninput = function () {
	        return controlToSlider(fromSlider, toSlider, toInput);
	    };
	    fromInput.addEventListener('blur', function () {
	        return controlFromInput(fromSlider, fromInput, toInput, toSlider);
	    });
	    toInput.addEventListener('blur', function () {
	        return controlToInput(toSlider, fromInput, toInput, toSlider);
	    });
	}

	$('.container').on('input', '#fromSlider, #toSlider', function (event) {
	    var fromSlider = document.querySelector('#fromSlider');
	    var toSlider = document.querySelector('#toSlider');
	    var fromInput = document.querySelector('#fromInput');
	    var toInput = document.querySelector('#toInput');

	    if (!fromSlider || !toSlider || !fromInput || !toInput) {
	        return;
	    }

	    if (event.target === fromSlider) {
	        controlFromSlider(fromSlider, toSlider, fromInput);
	    }
	    if (event.target === toSlider) {
	        controlToSlider(fromSlider, toSlider, toInput);
	    }
	});

	function updateURLParameter(url, params) {
	    var currUrl = void 0;
	    if (url.charAt(0) === '/') {
	        currUrl = new URL(window.origin + url);
	    } else {
	        currUrl = new URL(url);
	    }

	    Object.keys(params).forEach(function (param) {
	        currUrl.searchParams.set(param, params[param]);
	    });

	    return currUrl.pathname + currUrl.search;
	}

	$('.container').on('change, input, blur', '.js-minPriceFilter', function () {
	    var minPrice = $('.js-minPriceFilter').val();
	    var maxPrice = $('.js-maxPriceFilter').val();
	    var oldMinPrice = $('.cc-plp--filters--sticky').attr('data-new-min-price') ? $('.cc-plp--filters--sticky').attr('data-new-min-price') : $('.js-filterPrice').attr('data-old-min-price');
	    var initialMinPrice = $('.js-filterPrice').attr('data-available-min-price') || $('.js-filterPrice').attr('data-old-min-price');

	    if (parseInt(minPrice) !== parseInt(oldMinPrice)) {
	        if (parseInt(minPrice) < parseInt(initialMinPrice) || parseInt(minPrice) >= parseInt(maxPrice)) {
	            $('.js-minPriceFilter').val(parseInt(oldMinPrice));
	            return;
	        }

	        if (parseInt(minPrice) === parseInt(oldMinPrice)) {
	            minPrice = parseInt(oldMinPrice) - 1;
	            $('.js-minPriceFilter').val(parseInt(minPrice));
	        }
	    }

	    changeInput();
	});

	$('.container').on('change, input, blur', '.js-maxPriceFilter', function () {
	    var maxPrice = $('.js-maxPriceFilter').val();
	    var minPrice = $('.js-minPriceFilter').val();
	    var oldMaxPrice = $('.cc-plp--filters--sticky').attr('data-new-max-price') ? $('.cc-plp--filters--sticky').attr('data-new-max-price') : $('.js-filterPrice').attr('data-old-max-price');
	    var initialMaxPrice = $('.js-filterPrice').attr('data-available-max-price') || $('.js-filterPrice').attr('data-old-max-price');

	    if (parseInt(maxPrice) !== parseInt(oldMaxPrice)) {
	        if (parseInt(maxPrice) > parseInt(initialMaxPrice) || parseInt(maxPrice) <= parseInt(minPrice)) {
	            $('.js-maxPriceFilter').val(parseInt(oldMaxPrice));
	            $('.js-applyPrice').closest('.js-dropdownFilter').trigger('click');
	            return;
	        }

	        if (parseInt(minPrice) === parseInt(maxPrice)) {
	            maxPrice = parseInt(maxPrice) + 1;
	            $('.js-maxPriceFilter').val(parseInt(maxPrice));
	        }
	    }

	    changeInput();
	});

	$('.container').on('click', '.js-applyPrice', function (element) {
	    var _this = this;

	    setTimeout(function () {
	        var maxPrice = $('.js-maxPriceFilter').val();
	        var minPrice = $('.js-minPriceFilter').val();

	        $.spinner().start();

	        if (element) {
	            $(element).trigger('search:filter', element);
	        }

	        var currentUrl = $(_this).closest('.cc-plp--filterDropdown').find('.cc-plp--filterDropdown--inputPriceContent').data('href');
	        var newURL = updateURLParameter(currentUrl, {
	            pmax: maxPrice,
	            pmin: minPrice
	        });

	        $('.cc-plp--filters--sticky').attr('data-new-min-price', minPrice).attr('data-new-max-price', maxPrice);

	        if (!newURL) {
	            return;
	        }

	        $.ajax({
	            url: newURL,
	            data: {
	                page: $('.grid-footer').data('page-number'),
	                selectedUrl: newURL
	            },
	            method: 'GET',
	            success: function success(response) {
	                parseResults(response);

	                var minPrice = $('.cc-plp--filters--sticky').attr('data-new-min-price'),
	                    maxPrice = $('.cc-plp--filters--sticky').attr('data-new-max-price');

	                if (minPrice) {
	                    $('#fromSlider').val(minPrice);
	                    $('#fromInput').val(minPrice);
	                }

	                if (maxPrice) {
	                    $('#toSlider').val(maxPrice);
	                    $('#toInput').val(maxPrice);
	                }

	                var fromSlider = document.querySelector('#fromSlider');
	                var toSlider = document.querySelector('#toSlider');

	                if (fromSlider && toSlider) {
	                    fillSlider(fromSlider, toSlider, '#E7E6DD', '#000', toSlider);
	                    setToggleAccessible(toSlider);

	                    var url = $('.cc-plp--filterDropdown--inputPriceContent').attr('data-href'),
	                        urlRedirect = $('.cc-plp--filterDropdown--inputPriceContent').attr('data-redirect-url'),
	                        newURL = updateURLParameter(url, {
	                        pmax: maxPrice,
	                        pmin: minPrice
	                    }),
	                        newUrlRedirect = updateURLParameter(urlRedirect, {
	                        pmax: maxPrice,
	                        pmin: minPrice
	                    });

	                    pushFilterUrlState(newURL, newUrlRedirect);
	                }

	                if ($('.cc-plp--filterDropdown--sortingLabel [aria-expanded="true"]').length > 0) {
	                    $('.cc-plp--filterDropdown--sortingLabel .js-dropdownFilter').trigger('click');
	                }

	                $([document.documentElement, document.body]).animate({
	                    scrollTop: 0
	                }, 300);

	                $.spinner().stop();
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    }, 200);
	});

	$('body').on('click', '.js-toTopButton', function () {
	    $('html, body').animate({
	        scrollTop: 0
	    }, 300);
	});

	// Focus management for filter modal
	function getFocusableElements($container) {
	    var selector = 'a[href], button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
	    return $container.find(selector).filter(function (_, el) {
	        return $(el).attr('tabindex') !== '-1';
	    });
	}

	function trapFocusInContainer($container, e) {
	    var $focusable = getFocusableElements($container);
	    if (!$focusable.length) {
	        return;
	    }

	    var _ref = [$focusable.first()[0], $focusable.last()[0]],
	        firstElement = _ref[0],
	        lastElement = _ref[1];

	    var active = document.activeElement;

	    if (!$container.toArray().some(function (el) {
	        return el.contains(active);
	    })) {
	        return;
	    }

	    if (e.shiftKey && active === firstElement || !e.shiftKey && active === lastElement) {
	        e.preventDefault();
	        e.stopPropagation();
	        (e.shiftKey ? lastElement : firstElement).focus();
	    }
	}

	function trapFocus(e) {
	    if (e.key !== 'Tab') {
	        return;
	    }

	    var $dropdown = $('.cc-plp--filterDropdown.cc-plp--filterDropdown--open, .cc-plp--filterDropdown.show');
	    if ($dropdown.length && $dropdown.is(':visible')) {
	        var $buttonWrapper = $dropdown.find('.cc-plp--filterDropdown--buttonWrapper').first();

	        if (!$buttonWrapper.length && $dropdown.attr('name') === 'sorting') {
	            $buttonWrapper = $dropdown.siblings('.cc-plp--filterDropdown--buttonWrapper').first();
	        }

	        var $visibleButton = $buttonWrapper.find('button:visible').first();
	        var $container = $buttonWrapper.length && $visibleButton.length ? $dropdown.add($buttonWrapper) : $dropdown;
	        trapFocusInContainer($container, e);
	        return;
	    }

	    if ($('.cc-plp--filterModal.show').length) {
	        trapFocusInContainer($('.cc-plp--filterModal--container'), e);
	    }
	}

	function restoreFocus(selector) {
	    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;

	    if (!selector) {
	        return;
	    }
	    setTimeout(function () {
	        var $element = $(selector);
	        if ($element.length) {
	            $element[0].focus();
	        }
	    }, delay);
	}

	function closeFilterDropdownAndRestoreFocus() {
	    var $openDropdown = $('.cc-plp--filterDropdown.cc-plp--filterDropdown--open, .cc-plp--filterDropdown.show');
	    if (!$openDropdown.length) {
	        return;
	    }

	    if ($openDropdown.hasClass('show')) {
	        $openDropdown.removeClass('show').closest('.cc-submenu-voice').find('.js-dropdownFilter').attr('aria-expanded', 'false');

	        if (lastFocusedFilterIdentifier) {
	            restoreFocus('.js-dropdownFilter[data-refinement-trigger="trigger-' + lastFocusedFilterIdentifier + '"]');
	            lastFocusedFilterIdentifier = null;
	        }
	        return;
	    }

	    $openDropdown.removeClass('cc-plp--filterDropdown--open').closest('.cc-submenu-voice').addClass('d-none');
	    $('.cc-plp--filterRow--item').removeClass('cc-plp--filterRow--item--active');
	    $('.cc-submenu-voice, .cc-plp--filterRow--list').removeClass('d-none');

	    if (lastFocusedFilterIdentifier) {
	        setTimeout(function () {
	            var targetButton = document.querySelector('.cc-plp--filterModal--containerMobile .js-dropdownFilterMobile[data-refinement-trigger="' + lastFocusedFilterIdentifier + '"]');
	            if (targetButton) {
	                targetButton.focus();
	            }
	            lastFocusedFilterIdentifier = null;
	        }, 150);
	    }
	}

	function closeModalAndRestoreFocus() {
	    $('.cc-plp--filterModal').modal('hide').removeClass('show').css('display', 'none').attr('aria-hidden', 'true');
	    $('body').removeClass('modal-open');
	    $('.modal-backdrop').remove();
	    $('.cc-plp--filters--sticky').css({ position: 'sticky', 'z-index': '3' });

	    lastFocusedFilterIdentifier = null;
	    restoreFocus(lastFocusedElementSelector, 100);
	    lastFocusedElementSelector = null;
	}

	document.addEventListener('keydown', function (e) {
	    if (e.key !== 'Escape' && e.keyCode !== 27) {
	        return;
	    }

	    var $openDropdown = $('.cc-plp--filterDropdown.cc-plp--filterDropdown--open, .cc-plp--filterDropdown.show');
	    var isModalOpen = $('.cc-plp--filterModal.show').length > 0;

	    // Level 3 → Level 2: Close dropdown, return focus to modal button
	    if ($openDropdown.length) {
	        e.preventDefault();
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        closeFilterDropdownAndRestoreFocus();
	        return false;
	    }

	    // Level 2 → Level 1: Close modal, return focus to page button
	    if (isModalOpen) {
	        closeModalAndRestoreFocus();
	    }
	}, true);

	$(document).on('keydown', trapFocus);

	$('.container').on('click', '.js-openAccordion', function () {
	    if ($('.cc-plp--filterModal').hasClass('show')) {
	        return;
	    }

	    var accordionName = $(this).data('open-accordion');
	    if (accordionName) {
	        lastFocusedElementSelector = '.js-openAccordion[data-open-accordion="' + accordionName + '"]';
	    } else if ($(this).hasClass('icon-plp-filter')) {
	        lastFocusedElementSelector = '.js-openAccordion.icon-plp-filter';
	    } else {
	        lastFocusedElementSelector = '.js-openAccordion';
	    }
	});

	$('.container').on('keydown', '.js-openAccordion', function (e) {
	    if (e.key === 'Enter' || e.key === ' ') {
	        e.preventDefault();
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        $(this).trigger('click');
	    }
	});

	$('.container').on('keydown', '.cc-checkbox, .cc-check-label, .js-applyFilter', function (e) {
	    if (e.key !== ' ' && e.key !== 'Spacebar') {
	        return;
	    }
	    e.preventDefault();

	    var $target = $(this);

	    if ($target.hasClass('js-applyFilter') && $target.find('.cc-color').length) {
	        $target.trigger('click');
	        return;
	    }

	    var $checkbox = void 0;
	    if ($target.hasClass('js-applyFilter')) {
	        $checkbox = $target.find('.cc-checkbox');
	    } else if ($target.hasClass('cc-checkbox')) {
	        $checkbox = $target;
	    } else {
	        $checkbox = $target.prev('.cc-checkbox');
	    }

	    if ($checkbox.length) {
	        $checkbox.trigger('click');
	    }
	});

	// In Firefox the input type="number" allows the user to write/paste any value (including letters), so we need to prevent this
	$('.container').on('keypress', '.js-minPriceFilter, .js-maxPriceFilter', function (e) {
	    var allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
	    if (!allowedKeys.includes(e.key)) {
	        e.preventDefault();
	    }
	});
	$('.container').on('paste', '.js-minPriceFilter, .js-maxPriceFilter', function (e) {
	    var paste = (e.clipboardData || window.clipboardData).getData('text');
	    if (!/^\d+$/.test(paste)) {
	        e.preventDefault();
	    }
	});

	// Promo Banner Login button - lazy-load the login modal via the existing
	// Wishlist-LoginFromMinicart endpoint. The modal is tagged with data-login-source="promoBanner"
	// so login.js reloads the current page on success only for this flow.
	$(document).on('click', '.js-pd-promoBanner-loginButton', function (e) {
	    e.preventDefault();

	    var url = $(this).data('login-url');
	    if (!url) {
	        return;
	    }

	    $.spinner().start();
	    $.ajax({
	        url: url,
	        type: 'post',
	        success: function success(data) {
	            // remove old modal
	            $('#loginDrawerModal').remove();

	            // append new modal
	            $('body').append(data);

	            var $modal = $('#loginDrawerModal');
	            $.spinner().stop();
	            $modal.find('form.login').attr('data-login-source', 'promoBanner');
	            if (window.isMobile) {
	                $('#loginDrawerModal').addClass('cc-general-login');
	                $('#loginDrawerModal').removeClass('cc-modal-express-checkout');
	            }
	            $modal.modal('show');
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	});

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var addToCartHelper = __webpack_require__(197);

	// Modify the wishlist-add button like normal behavior, if the product can be added or not
	function handleWishlistButtonInTile($element, isInWishlist) {

	    var $button = $element.find('button.add-to-wish-list');
	    var isSizeSelected = !!$button.data('is-size-selected');
	    var isPLPProductAlreadyWishlisted;
	    // Checking if that product is already in wishlist while on PLP (changing tiles)
	    if (window.ProductsInWishlist) {
	        var productArr = window.ProductsInWishlist;
	        var pid = $element.data('pid');
	        isPLPProductAlreadyWishlisted = productArr.indexOf(pid) > -1;
	    } else {
	        isPLPProductAlreadyWishlisted = false;
	    }
	    var $spanAdd = $button.find('span.wishlist-content-add').length ? $button.find('span.wishlist-content-add') : $button.find('svg.wishlist-content-add');
	    var $spanRemove = $button.find('span.wishlist-content-remove').length ? $button.find('span.wishlist-content-remove') : $button.find('svg.wishlist-content-remove');

	    if (isSizeSelected || isPLPProductAlreadyWishlisted) {
	        if (isInWishlist) {
	            $button.addClass('to-remove');
	            $button.removeClass('to-add');
	            $button.attr('data-variation-group', 'to-remove');

	            $spanAdd.addClass('d-none');
	            $spanRemove.removeClass('d-none');
	        } else {
	            $button.addClass('to-add');
	            $button.removeClass('to-remove');
	            $button.attr('data-variation-group', 'to-add');

	            $spanRemove.addClass('d-none');
	            $spanAdd.removeClass('d-none');
	        }
	    }
	}

	// This function check if the pid in argument is included in the array of products' PID in wishlist
	function checkInWishlist(classToRefresh) {
	    var productArr = window.ProductsInWishlist;

	    if (!productArr) {
	        return false;
	    }

	    var $element = $('.' + classToRefresh).find('.product.product-tile');
	    var newPid = $element.data('pid');
	    if (productArr.indexOf(newPid) > -1) {
	        handleWishlistButtonInTile($element, true);
	    } else {
	        handleWishlistButtonInTile($element, false);
	    }
	}

	// Create in window object an array of PID of the wishlist products
	function productsInWishlistOnDOMready() {
	    window.ProductsInWishlist = [];

	    var productArrString = $('.wishlist-list.products-in-wishlist').attr('data-products-in-wishlist');

	    if (!productArrString) {
	        return;
	    }

	    var productObj = JSON.parse(productArrString);
	    var productArr = productObj.result;

	    if (!productArr) {
	        return;
	    }

	    window.ProductsInWishlist = productArr;

	    $('.product-grid .column-tile .product.product-tile').each(function () {
	        var pid = $(this).data('pid');
	        if (productArr.indexOf(pid) > -1) {
	            handleWishlistButtonInTile($(this), true);
	        } else {
	            handleWishlistButtonInTile($(this), false);
	        }
	    });
	}

	// Handles click actions based on whether the product should be added to the wishlist or cart,
	// then resets size buttons and closes modal.
	function actionAfterSelectSize(classToRefresh) {
	    var $objTile = $('.' + classToRefresh);
	    var $btnAddToCart = $objTile.find('.add-to-cart').length > 0 ? $objTile.find('.add-to-cart') : $('.add-to-cart');
	    var $wishlistBtn = $objTile.find('.add-to-wish-list');

	    // Ensure $btnAddToCart targets only the button for the selected size
	    var selectedVgId = $('.js-sizeBtn.active').data('vg-id');
	    if (selectedVgId) {
	        // Find the add-to-cart button whose data-pid is a substring of selectedVgId
	        var $matchingBtn = $btnAddToCart.filter(function () {
	            var btnPid = $(this).data('pid');
	            return selectedVgId.indexOf(btnPid) !== -1;
	        });
	        if ($matchingBtn.length) {
	            $btnAddToCart = $matchingBtn.first();
	        }
	    }
	    // In case there is a duplicated product ID, handle only that case.
	    // else if ($btnAddToCart.length > 1) {
	    //     $btnAddToCart = $btnAddToCart.first();
	    // }

	    if ($objTile.hasClass('js-addWishlist')) {
	        $wishlistBtn.trigger('click');
	        $objTile.removeClass('js-addWishlist');
	    } else {
	        $btnAddToCart.trigger('click');
	    }

	    // $('.js-sizeBtn').removeClass('active');
	    var hasPreSelectedSize = $objTile.attr('data-has-preselected-size') === 'true';

	    // Only remove active class if there's no pre-selected size
	    if (!hasPreSelectedSize) {
	        $('.js-sizeBtn').removeClass('active');
	    }
	    $('body').removeClass('modal-open');

	    // Close wishlist size modal if applicable
	    $('.cc-wishlist-card.js-tileWrapperHover').removeClass('js-tileWrapperHover');
	    $('.cc-wishlist-card .cc-tile-sizes.cc-active').removeClass('cc-active');
	    $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');
	}

	// Function for initializing event listeners
	function initializeEventListeners() {
	    // Tile sizes
	    $(document).on('click keydown', '.js-tile-open-overlay', function (e) {
	        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
	            return;
	        }
	        e.stopPropagation();
	        e.stopImmediatePropagation();
	        e.preventDefault();

	        var $self = $(this);
	        if ($self.hasClass('js-noSize')) {
	            $self.closest('.cc-col-tile').find('.add-to-cart').trigger('click');
	        } else {
	            $('.js-tileWrapper').removeClass('js-tileWrapperHover');
	            $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	            $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');

	            var $sizeModal = $self.closest('.cc-tile-body').find('.cc-tile-sizes');
	            $sizeModal.addClass('cc-active');
	            $self.closest('.js-tileWrapper').addClass('js-tileWrapperHover');

	            if (!window.isDesktop) {
	                $('body').addClass('modal-open');
	            }

	            $sizeModal.find('.js-sizeBtn:first').trigger('focus');
	        }
	    });

	    $('.container').on('mouseleave', '.js-tileWrapperHover', function () {
	        if (window.isDesktop) {
	            var $self = $(this);

	            $self.removeClass('js-tileWrapperHover');
	            $self.find('.cc-tile-sizes').removeClass('cc-active');
	            $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');
	        }
	    });

	    $(document).on('click', '.js-close-size', function (e) {
	        e.stopPropagation();
	        e.preventDefault();
	        $(this).closest('.cc-tile-sizes').removeClass('cc-active');
	        $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');
	    });

	    $(document).on('click', function (e) {
	        e.stopPropagation();

	        var $sizeModal = $('.cc-tile-sizes');

	        if (!$sizeModal.length > 0 || !($sizeModal.length > 0 && $sizeModal.hasClass('cc-active')) || $(e.target).prop('class') === 'cc-tile-sizes__wrp' || $(e.target).closest('.cc-tile-sizes__wrp').length > 0) {
	            return;
	        }

	        $sizeModal.removeClass('cc-active');
	        $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');

	        if (!window.isDesktop) {
	            $('body').removeClass('modal-open');
	        }
	    });

	    $(document).on('keydown', function (e) {
	        if (e.key === 'Escape') {
	            var $activeSizeModal = $('.cc-tile-sizes.cc-active');
	            if ($activeSizeModal.length) {
	                var $tileOpenButton = $activeSizeModal.closest('.cc-tile-body').find('.js-tile-open-overlay');
	                $activeSizeModal.removeClass('cc-active');
	                $('.experience-commerce_carousel_product-productListContentSlot').css('z-index', '1');
	                $tileOpenButton.trigger('focus');
	            }
	        }
	    });
	}

	function scrollActiveColorsIntoView() {
	    $('.cc-color-link-content-activate.active').each(function () {
	        var $selectedColor = $(this);
	        var $colorContainer = $selectedColor.closest('.cc-color');
	        if ($colorContainer.length > 0) {
	            var containerWidth = $colorContainer.width();
	            var selectedColorLeft = $selectedColor.position().left;
	            var selectedColorWidth = $selectedColor.outerWidth();

	            if (selectedColorLeft < 0 || selectedColorLeft + selectedColorWidth > containerWidth) {
	                var scrollTo = selectedColorLeft - containerWidth / 2 + selectedColorWidth / 2;
	                $colorContainer.scrollLeft(Math.max(0, scrollTo));
	            }
	        }
	    });
	}

	$(function () {
	    productsInWishlistOnDOMready();
	    initializeEventListeners();
	    scrollActiveColorsIntoView();
	});

	module.exports = {
	    productsInWishlistOnDOMready: productsInWishlistOnDOMready,
	    refreshPLPTile: function refreshPLPTile() {
	        // Handle click and keyboard events on product tile color or size. This function refreshes this section
	        $('.container').on('click keydown', '.changeTileSelection a', function (e) {
	            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
	                return;
	            }
	            e.preventDefault();
	            e.stopPropagation();
	            var variationType = "";
	            if ($(this).closest('.cc-size-list').length > 0) {
	                variationType = "size";
	            } else if ($(this).closest('.cc-color').length > 0) {
	                variationType = "color";
	            }

	            $(this).addClass('active');
	            var classToRefresh = $(this).data('classtorefresh');

	            var isSize = true;
	            var attrColor = $(this).attr('data-color');
	            var variationValue = $(this).attr('title');

	            if (typeof attrColor !== 'undefined' && attrColor !== false) {
	                isSize = false;
	            }

	            $.ajax({
	                url: $(this).data('refreshtileurl'),
	                data: {
	                    selectedUrl: $(this).data('refreshtileurl'),
	                    classToRefresh: $(this).data('classtorefresh'),
	                    isAjax: true,
	                    isSize: isSize,
	                    variationValue: variationValue
	                },
	                method: 'GET',
	                success: function (variation) {
	                    return function (response) {
	                        if ($('.' + classToRefresh).length === 0) {
	                            if ($('.' + classToRefresh + '__null').length > 0) {
	                                classToRefresh += '__null';
	                            }
	                        }

	                        var $tile = $('.' + classToRefresh);
	                        var $analyticsProduct = $tile.find('.analytics-product');

	                        var position = $analyticsProduct.data('position') || 0;

	                        var focusedColorId = e.target.getAttribute('data-color');
	                        var $savedColors = isSize ? $tile.find('.color-swatches.cc-color-swatches').clone() : null;

	                        $tile.empty().html(response);

	                        if ($savedColors && $savedColors.length) {
	                            var $target = $tile.find('.color-swatches.cc-color-swatches, .color-swatches-placeholder').first();
	                            if ($target.length) $target.replaceWith($savedColors);
	                        }

	                        checkInWishlist(classToRefresh);

	                        var $wishlistBtn = $tile.find('.add-to-wish-list');
	                        var $productTile = $wishlistBtn.closest('.product-tile');
	                        if ($wishlistBtn.length && !$productTile.hasClass('to-add') && !$wishlistBtn.hasClass('to-remove')) {
	                            $productTile.find('.cc-tile-add-to-wishlist').addClass('to-add');
	                        }

	                        $('.cc-label-clubprice').addClass('icon-bata-club-price-cz');

	                        if (focusedColorId && !isSize) {
	                            $tile.find('a[data-color="' + focusedColorId + '"]').trigger('focus');
	                        }

	                        $tile.find('.analytics-product').data('position', position);
	                        var analyticsData = $analyticsProduct.data() || {};

	                        if (variationValue && analyticsData) {
	                            if (isSize) {
	                                analyticsData.size = variationValue;
	                                $('body').trigger('analytics:selectSize', {
	                                    productData: analyticsData
	                                });
	                            } else {
	                                analyticsData.color = variationValue;
	                                $('body').trigger('analytics:selectColor', {
	                                    productData: analyticsData
	                                });
	                            }
	                        }

	                        $('body').trigger('analytics:variantSelectionPLP', {
	                            productData: analyticsData,
	                            variationType: variation
	                        });

	                        if (isSize) {
	                            actionAfterSelectSize(classToRefresh);
	                        } else {
	                            scrollActiveColorsIntoView();
	                        }
	                    };
	                }(variationType),

	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        });
	    },
	    addToCart: addToCartHelper.addToCart
	};

/***/ })

/******/ });